import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Typography,
  TextField,
  IconButton,
  Avatar,
  Chip,
  CircularProgress,
  Alert,
  Badge,
  Collapse,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  Button,
  Snackbar,
  useTheme,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ChatIcon from '@mui/icons-material/Chat';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import ReplyIcon from '@mui/icons-material/Reply';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FilterListIcon from '@mui/icons-material/FilterList';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Pusher from 'pusher-js';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Импортируем иконки для папок
import WorkIcon from '@mui/icons-material/Work';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import SchoolIcon from '@mui/icons-material/School';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CategoryIcon from '@mui/icons-material/Category';
import LabelIcon from '@mui/icons-material/Label';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ArchiveIcon from '@mui/icons-material/Archive';
import InboxIcon from '@mui/icons-material/Inbox';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SportsIcon from '@mui/icons-material/Sports';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import FlightIcon from '@mui/icons-material/Flight';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HotelIcon from '@mui/icons-material/Hotel';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SecurityIcon from '@mui/icons-material/Security';
import LockIcon from '@mui/icons-material/Lock';
import PublicIcon from '@mui/icons-material/Public';
import CodeIcon from '@mui/icons-material/Code';
import ComputerIcon from '@mui/icons-material/Computer';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventIcon from '@mui/icons-material/Event';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AssignmentIcon from '@mui/icons-material/Assignment';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EventNoteIcon from '@mui/icons-material/EventNote';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DownloadIcon from '@mui/icons-material/Download';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import Checkbox from '@mui/material/Checkbox';
import AddIcon from '@mui/icons-material/Add';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ForumIcon from '@mui/icons-material/Forum';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import StoreIcon from '@mui/icons-material/Store';
import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HistoryIcon from '@mui/icons-material/History';
import ScheduleIcon from '@mui/icons-material/Schedule';
import NoteIcon from '@mui/icons-material/Note';
import ArticleIcon from '@mui/icons-material/Article';
import CollectionsIcon from '@mui/icons-material/Collections';
import MovieIcon from '@mui/icons-material/Movie';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';

// Список доступных иконок для папок
const folderIcons = {
  Folder: FolderIcon,
  FolderOpen: FolderOpenIcon,
  Work: WorkIcon,
  Business: BusinessIcon,
  Home: HomeIcon,
  Star: StarIcon,
  Favorite: FavoriteIcon,
  Settings: SettingsIcon,
  Build: BuildIcon,
  School: SchoolIcon,
  ShoppingCart: ShoppingCartIcon,
  Category: CategoryIcon,
  Label: LabelIcon,
  Bookmark: BookmarkIcon,
  Archive: ArchiveIcon,
  Inbox: InboxIcon,
  Description: DescriptionIcon,
  Image: ImageIcon,
  VideoLibrary: VideoLibraryIcon,
  MusicNote: MusicNoteIcon,
  Sports: SportsIcon,
  Restaurant: RestaurantIcon,
  Flight: FlightIcon,
  DirectionsCar: DirectionsCarIcon,
  Hotel: HotelIcon,
  LocalHospital: LocalHospitalIcon,
  AccountBalance: AccountBalanceIcon,
  Security: SecurityIcon,
  Lock: LockIcon,
  Public: PublicIcon,
  Code: CodeIcon,
  Computer: ComputerIcon,
  Phone: PhoneIcon,
  Email: EmailIcon,
  CalendarToday: CalendarTodayIcon,
  Event: EventIcon,
  Notifications: NotificationsIcon,
  Assignment: AssignmentIcon,
  CheckCircle: CheckCircleIcon,
  Warning: WarningIcon,
  Info: InfoIcon,
  Help: HelpIcon,
  Forum: ForumIcon,
  Group: GroupIcon,
  Person: PersonIcon,
  BusinessCenter: BusinessCenterIcon,
  Store: StoreIcon,
  Payment: PaymentIcon,
  AttachMoney: AttachMoneyIcon,
  TrendingUp: TrendingUpIcon,
  BarChart: BarChartIcon,
  Dashboard: DashboardIcon,
  History: HistoryIcon,
  Schedule: ScheduleIcon,
  Note: NoteIcon,
  Article: ArticleIcon,
  Collections: CollectionsIcon,
  Movie: MovieIcon,
  LibraryMusic: LibraryMusicIcon,
};

// Функция для получения компонента иконки по имени
const getIconComponent = (iconName) => {
  if (!iconName || !folderIcons[iconName]) {
    return FolderIcon;
  }
  const IconComponent = folderIcons[iconName];
  return IconComponent;
};

const Messages = () => {
  const { user } = useAuth();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Функция для получения полного URL файла
  const getFileUrl = (chatUuid, messageId) => {
    const API_URL = process.env.REACT_APP_API_URL || '';
    // Если API_URL установлен и не пустой, используем его
    // Иначе используем относительный путь (будет работать через прокси)
    if (API_URL && API_URL.trim() !== '') {
      // Убираем слэш в конце, если есть
      const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
      return `${baseUrl}/api/messages/${chatUuid}/${messageId}/file`;
    }
    // Используем относительный путь - прокси должен перенаправить на backend
    return `/api/messages/${chatUuid}/${messageId}/file`;
  };
  const [projects, setProjects] = useState([]);
  const [selectedProjectUuid, setSelectedProjectUuid] = useState(null);
  const [chats, setChats] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  // Загружаем lastViewedTimes из localStorage при инициализации
  const [lastViewedTimes, setLastViewedTimes] = useState(() => {
    try {
      const saved = localStorage.getItem('lastViewedTimes');
      return saved ? JSON.parse(saved) : {};
    } catch (error) {
      console.error('Error loading lastViewedTimes from localStorage:', error);
      return {};
    }
  });
  const [unreadMessages, setUnreadMessages] = useState({});
  
  // Сохраняем lastViewedTimes в localStorage при изменении
  useEffect(() => {
    try {
      localStorage.setItem('lastViewedTimes', JSON.stringify(lastViewedTimes));
    } catch (error) {
      console.error('Error saving lastViewedTimes to localStorage:', error);
    }
  }, [lastViewedTimes]);
  const [expandedFolders, setExpandedFolders] = useState({});
  const [chatMenuAnchor, setChatMenuAnchor] = useState(null);
  const [selectedChatForMenu, setSelectedChatForMenu] = useState(null);
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  const [moveChatDialogOpen, setMoveChatDialogOpen] = useState(false);
  const [messageMenuAnchor, setMessageMenuAnchor] = useState(null);
  const [selectedMessageForMenu, setSelectedMessageForMenu] = useState(null);
  const [editMessageDialogOpen, setEditMessageDialogOpen] = useState(false);
  const [editMessageText, setEditMessageText] = useState('');
  const [replyToMessage, setReplyToMessage] = useState(null);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [createTaskDialogOpen, setCreateTaskDialogOpen] = useState(false);
  const [editTaskDialogOpen, setEditTaskDialogOpen] = useState(false);
  const [taskForm, setTaskForm] = useState({ title: '', description: '', due_date: '' });
  const [selectedTask, setSelectedTask] = useState(null);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());
  const [selectedMessagesForTask, setSelectedMessagesForTask] = useState([]);
  const [taskSelectionMode, setTaskSelectionMode] = useState(false);
  const [taskCounts, setTaskCounts] = useState({}); // { chatUuid: count }
  const [viewTaskMessagesDialogOpen, setViewTaskMessagesDialogOpen] = useState(false);
  const [selectedTaskForView, setSelectedTaskForView] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [templatesDialogOpen, setTemplatesDialogOpen] = useState(false);
  const [templateFormOpen, setTemplateFormOpen] = useState(false);
  const [templateForm, setTemplateForm] = useState({ name: '', text: '' });
  const [selectedTemplateForEdit, setSelectedTemplateForEdit] = useState(null);
  const [templateMenuAnchor, setTemplateMenuAnchor] = useState(null);
  const [selectedTemplateForMenu, setSelectedTemplateForMenu] = useState(null);
  const [playingAudioId, setPlayingAudioId] = useState(null);
  const [audioBlobUrls, setAudioBlobUrls] = useState({}); // { messageId: blobUrl }
  const [loadingAudio, setLoadingAudio] = useState(new Set()); // Set of messageIds
  const [stickyDate, setStickyDate] = useState(null); // Дата для sticky header
  const audioPlayerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const pusherRef = useRef(null);
  const channelsRef = useRef({});
  const audioRef = useRef(null);

  // Активируем AudioContext при первом взаимодействии пользователя
  useEffect(() => {
    const activateAudioContext = async () => {
      try {
        if (!audioRef.current) {
          const audioContext = new (window.AudioContext || window.webkitAudioContext)();
          audioRef.current = audioContext;
          
          // Пытаемся активировать контекст
          if (audioContext.state === 'suspended') {
            await audioContext.resume();
          }
        }
      } catch (error) {
        console.warn('Не удалось активировать AudioContext:', error);
      }
    };

    // Активируем при любом взаимодействии пользователя
    const events = ['click', 'touchstart', 'keydown'];
    const handlers = events.map(event => {
      const handler = () => {
        activateAudioContext();
        events.forEach(e => document.removeEventListener(e, handlers[events.indexOf(e)]));
      };
      return handler;
    });

    events.forEach((event, index) => {
      document.addEventListener(event, handlers[index], { once: true });
    });

    return () => {
      events.forEach((event, index) => {
        document.removeEventListener(event, handlers[index]);
      });
    };
  }, []);

  // Функция для воспроизведения звука отправки сообщения (короткий "тынь")
  const playSendSound = async () => {
    try {
      // Создаем или используем существующий AudioContext
      let audioContext = audioRef.current;
      
      if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioRef.current = audioContext;
      }

      // Если контекст приостановлен (заблокирован браузером), пытаемся возобновить
      if (audioContext.state === 'suspended') {
        try {
          await audioContext.resume();
        } catch (resumeError) {
          console.warn('Не удалось возобновить AudioContext:', resumeError);
          // Если не удалось возобновить, создаем новый контекст
          audioContext = new (window.AudioContext || window.webkitAudioContext)();
          audioRef.current = audioContext;
        }
      }

      // Создаем короткий звук "тынь" (один тон, выше по частоте)
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Более высокий тон для звука отправки
      oscillator.frequency.value = 1200;
      oscillator.type = 'sine';

      // Короткий звук с быстрым затуханием
      gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.1);
    } catch (error) {
      console.warn('Не удалось воспроизвести звук отправки:', error);
    }
  };

  // Функция для воспроизведения звука уведомления
  const playNotificationSound = async () => {
    try {
      // Создаем или используем существующий AudioContext
      let audioContext = audioRef.current;
      
      if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioRef.current = audioContext;
      }

      // Если контекст приостановлен (заблокирован браузером), пытаемся возобновить
      if (audioContext.state === 'suspended') {
        try {
          await audioContext.resume();
        } catch (resumeError) {
          console.warn('Не удалось возобновить AudioContext:', resumeError);
          // Если не удалось возобновить, создаем новый контекст
          audioContext = new (window.AudioContext || window.webkitAudioContext)();
          audioRef.current = audioContext;
        }
      }

      // Создаем простой звук уведомления через Web Audio API
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Более приятный звук уведомления (два тона)
      oscillator.frequency.value = 800;
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.15);

      // Второй тон для более заметного уведомления
      setTimeout(() => {
        try {
          const currentTime = audioContext.currentTime;
          const oscillator2 = audioContext.createOscillator();
          const gainNode2 = audioContext.createGain();

          oscillator2.connect(gainNode2);
          gainNode2.connect(audioContext.destination);

          oscillator2.frequency.value = 1000;
          oscillator2.type = 'sine';

          gainNode2.gain.setValueAtTime(0.3, currentTime);
          gainNode2.gain.exponentialRampToValueAtTime(0.01, currentTime + 0.15);

          oscillator2.start(currentTime);
          oscillator2.stop(currentTime + 0.15);
        } catch (error2) {
          console.warn('Не удалось воспроизвести второй тон:', error2);
        }
      }, 150);
    } catch (error) {
      console.warn('Не удалось воспроизвести звук уведомления:', error);
      // Пытаемся использовать альтернативный метод через HTML5 Audio
      try {
        const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjGH0fPTgjMGHm7A7+OZURAJR6Hh8sBtJAUwgM/z2IU4CB1tvvDmnlEQDE+n4fC2YxwGOJLX8sx5LAUkeMfw3ZBACxRes+nrqFUUCkaf4PK+bCEGMYfR89OCMwYebsDv45lREAlHoeHxwG0kBTCAz/PYhTgIHW2+8OaeURAMT6fh8LZjHAY4ktfyzHksBSR4x/DdkEALFF6z6euoVRQKRp/g8r5sIQYxh9Hz04IzBh5uwO/jmVEQCUeh4fHAbSQF MIDAP//wA==');
        audio.volume = 0.5;
        audio.play().catch(err => console.warn('Не удалось воспроизвести звук через Audio:', err));
      } catch (audioError) {
        console.warn('Не удалось использовать альтернативный метод:', audioError);
      }
    }
  };

  // Инициализация Pusher (один раз при монтировании)
  useEffect(() => {
    if (pusherRef.current) {
      return; // Уже инициализирован
    }

    const token = localStorage.getItem('token');
    const API_URL = process.env.REACT_APP_API_URL || '';
    const authEndpoint = API_URL ? `${API_URL}/api/auth/pusher/auth` : '/api/auth/pusher/auth';
    
    console.log('🔐 Настройка Pusher авторизации:', { authEndpoint, hasToken: !!token });

    const pusher = new Pusher('d67cc950a721a71cb34e', {
      cluster: 'eu',
      authEndpoint: authEndpoint,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      enabledTransports: ['ws', 'wss'],
    });
    
    // Обработка ошибок подключения
    pusher.connection.bind('error', (err) => {
      console.error('❌ Ошибка подключения Pusher:', err);
    });
    
    pusher.connection.bind('connected', () => {
      console.log('✅ Pusher подключен');
    });
    
    pusher.connection.bind('disconnected', () => {
      console.log('⚠️ Pusher отключен');
    });

    pusherRef.current = pusher;
    console.log('📡 Pusher инициализирован');

    return () => {
      // Отключаемся только при размонтировании компонента
      if (pusherRef.current) {
        console.log('📡 Отключаем Pusher');
        pusherRef.current.disconnect();
        pusherRef.current = null;
      }
    };
  }, []);

  // Подписка на канал пользователя для обновления списка чатов
  useEffect(() => {
    if (!pusherRef.current || !user?.id) return;

    const userChannel = pusherRef.current.subscribe(`user-${user.id}`);
    console.log(`📡 Подписываемся на канал user-${user.id}`);

    userChannel.bind('new-chat-message', async (data) => {
      console.log('📨 Получено событие new-chat-message через user channel:', data);
      
      // Проверяем доступ к чату по текущему списку чатов
      const hasAccessToChat = chats.some(chat => chat.uuid === data.chatUuid);
      if (!hasAccessToChat) {
        console.log('⚠️ Нет доступа к чату, обновляем список чатов для проверки:', data.chatUuid);
        // Обновляем список чатов для проверки доступа
        const fetchedChats = await fetchChats();
        const stillNoAccess = !fetchedChats || !fetchedChats.some(chat => chat.uuid === data.chatUuid);
        if (stillNoAccess) {
          console.log('⚠️ Нет доступа к чату, игнорируем уведомление:', data.chatUuid);
          // Отписываемся от канала чата, если подписаны
          const channelName = `private-chat-${data.chatUuid}`;
          if (channelsRef.current[data.chatUuid]) {
            console.log(`📡 Отписываемся от канала ${channelName} - нет доступа`);
            pusherRef.current?.unsubscribe(channelName);
            delete channelsRef.current[data.chatUuid];
          }
          return;
        }
      }
      
      // Обновляем последнее сообщение в списке чатов из пуша
      if (data.message && !data.message.deleted_at) {
        setChats(prevChats => {
          const updatedChats = prevChats.map(c => {
            if (c.uuid === data.chatUuid) {
              return {
                ...c,
                last_message_text: data.message.text || '',
                last_message_at: data.message.created_at,
                last_message_direction: data.message.direction,
                updated_at: data.message.created_at,
              };
            }
            return c;
          });
          
          // Сортируем чаты по дате последнего сообщения (самые новые сверху)
          updatedChats.sort((a, b) => {
            const dateA = new Date(a.last_message_at || a.updated_at || a.created_at || 0);
            const dateB = new Date(b.last_message_at || b.updated_at || b.created_at || 0);
            return dateB - dateA;
          });
          
          return updatedChats;
        });
      }
      
      // Воспроизводим звук уведомления, если чат не открыт
      if (!selectedChat || selectedChat.uuid !== data.chatUuid) {
        playNotificationSound();
      }
      
      if (selectedChat && selectedChat.uuid === data.chatUuid) {
        console.log('✅ Чат открыт, добавляем сообщение через user channel');
        
        // Воспроизводим звук уведомления для входящих сообщений в открытом чате
        if (data.message.direction === 'incoming' && !data.message.deleted_at) {
          playNotificationSound();
        }
        
        setMessages(prev => {
          // Если сообщение удалено, убираем его из списка
          if (data.message.deleted_at) {
            return prev.filter(m => m.id !== data.message.id);
          }
          
          // Проверяем, есть ли уже такое сообщение
          const existingIndex = prev.findIndex(m => m.id === data.message.id);
          if (existingIndex !== -1) {
            // Обновляем существующее сообщение
            const updated = [...prev];
            updated[existingIndex] = data.message;
            return updated;
          }
          
          // Добавляем новое сообщение
          return [...prev, data.message];
        });
      }
      
      // Воспроизводим звук уведомления, если чат не открыт
      if (!selectedChat || selectedChat.uuid !== data.chatUuid) {
        playNotificationSound();
      }
      
      if (selectedChat && selectedChat.uuid === data.chatUuid) {
        console.log('✅ Чат открыт, добавляем сообщение через user channel');
        
        // Воспроизводим звук уведомления для входящих сообщений в открытом чате
        if (data.message.direction === 'incoming' && !data.message.deleted_at) {
          playNotificationSound();
        }
        
        setMessages(prev => {
          // Если сообщение удалено, убираем его из списка
          if (data.message.deleted_at) {
            return prev.filter(m => m.id !== data.message.id);
          }
          // Проверяем, есть ли уже такое сообщение
          const existingIndex = prev.findIndex(m => m.id === data.message.id);
          if (existingIndex !== -1) {
            // Обновляем существующее сообщение (для редактирования)
            const updated = [...prev];
            updated[existingIndex] = data.message;
            return updated;
          }
          // Добавляем новое сообщение в конец (только если мы внизу списка)
          const container = messagesContainerRef.current;
          const isNearBottom = container && 
            (container.scrollHeight - container.scrollTop - container.clientHeight < 100);
          
          console.log('➕ Добавляем новое сообщение в список. Текущее количество:', prev.length);
          const newMessages = [...prev, data.message];
          
          // Прокручиваем вниз только если пользователь был внизу
          if (isNearBottom) {
            setTimeout(() => scrollToBottom(), 100);
          }
          
          return newMessages;
        });
      } else {
        // Не добавляем удаленные сообщения в непрочитанные
        if (!data.message.deleted_at) {
          setUnreadMessages(prev => ({
            ...prev,
            [data.chatUuid]: [...(prev[data.chatUuid] || []), data.message],
          }));
        }
      }
    });

    return () => {
      console.log(`📡 Отписываемся от канала user-${user.id}`);
      pusherRef.current?.unsubscribe(`user-${user.id}`);
    };
  }, [user?.id, selectedChat?.uuid]);

  // Подписка на канал открытого чата для получения новых сообщений
  useEffect(() => {
    if (!pusherRef.current || !selectedChat) {
      // Если чат закрыт, очищаем подписку
      return;
    }

    const chatUuid = selectedChat.uuid;
    const channelName = `private-chat-${chatUuid}`;

    // Отписываемся от старого канала открытого чата, если он был
    const previousChatUuid = Object.keys(channelsRef.current).find(
      uuid => uuid !== chatUuid && chats.find(c => c.uuid === uuid)
    );
    if (previousChatUuid && previousChatUuid !== chatUuid) {
      console.log(`📡 Отписываемся от предыдущего канала private-chat-${previousChatUuid}`);
      pusherRef.current?.unsubscribe(`private-chat-${previousChatUuid}`);
      delete channelsRef.current[previousChatUuid];
    }

    // Если уже подписаны на этот канал, перепривязываем обработчик
    let channel = channelsRef.current[chatUuid];
    
    if (!channel) {
      console.log(`📡 Подписываемся на канал ${channelName} для чата ${selectedChat.name}`);
      channel = pusherRef.current.subscribe(channelName);
      channelsRef.current[chatUuid] = channel;
      
      // Проверяем состояние подписки
      channel.bind('pusher:subscription_succeeded', () => {
        console.log(`✅ Успешно подписались на канал ${channelName}`);
      });

      channel.bind('pusher:subscription_error', (error) => {
        console.error(`❌ Ошибка подписки на канал ${channelName}:`, error);
        setError(`Ошибка подписки на канал: ${error.status || error.message || 'Неизвестная ошибка'}`);
      });
    } else {
      console.log(`📡 Уже подписаны на канал ${channelName}, перепривязываем обработчик`);
      // Отвязываем старый обработчик, если он был
      channel.unbind('new-message');
    }
    
    // Всегда привязываем обработчик для открытого чата
    channel.bind('new-message', (message) => {
      console.log('📨 Получено новое сообщение через Pusher для открытого чата:', message);
      console.log('📨 Данные сообщения:', { id: message.id, text: message.text?.substring(0, 50), direction: message.direction });
      
      // Проверяем, есть ли доступ к этому чату (чат должен быть в списке доступных)
      // Используем замыкание для получения актуального списка чатов
      const currentChats = chats;
      const hasAccessToChat = currentChats.some(chat => chat.uuid === chatUuid);
      if (!hasAccessToChat) {
        console.log('⚠️ Нет доступа к чату, игнорируем сообщение:', chatUuid);
        return;
      }
      
      // Воспроизводим звук уведомления для входящих сообщений
      if (message.direction === 'incoming' && !message.deleted_at) {
        playNotificationSound();
      }
      
      setMessages(prev => {
        console.log('📨 Текущее количество сообщений:', prev.length);
        
        // Если сообщение удалено, убираем его из списка
        if (message.deleted_at) {
          return prev.filter(m => m.id !== message.id);
        }
        
        // Проверяем, есть ли уже такое сообщение
        const existingIndex = prev.findIndex(m => m.id === message.id);
        if (existingIndex !== -1) {
          // Обновляем существующее сообщение (для редактирования)
          console.log('🔄 Обновляем существующее сообщение');
          const updated = [...prev];
          updated[existingIndex] = message;
          return updated;
        }
        
        // Добавляем новое сообщение в конец (только если мы внизу списка)
        const container = messagesContainerRef.current;
        const isNearBottom = container && 
          (container.scrollHeight - container.scrollTop - container.clientHeight < 100);
        
        console.log('➕ Добавляем новое сообщение в список. Текущее количество:', prev.length, 'Новое сообщение ID:', message.id);
        const newMessages = [...prev, message];
        console.log('➕ Новое количество сообщений:', newMessages.length);
        
        // Прокручиваем вниз только если пользователь был внизу
        if (isNearBottom) {
          setTimeout(() => scrollToBottom(), 100);
        }
        
        return newMessages;
      });
    });

    channelsRef.current[chatUuid] = channel;

    return () => {
      console.log(`📡 Отписываемся от канала ${channelName}`);
      if (channelsRef.current[chatUuid]) {
        pusherRef.current?.unsubscribe(channelName);
        delete channelsRef.current[chatUuid];
      }
    };
  }, [selectedChat?.uuid]);

  // Подписка на каналы всех чатов для обновления списка чатов (кроме открытого)
  useEffect(() => {
    if (!pusherRef.current) return;

    chats.forEach(chat => {
      const channelName = `private-chat-${chat.uuid}`;
      
      // Пропускаем канал открытого чата, он обрабатывается отдельно
      if (selectedChat && selectedChat.uuid === chat.uuid) {
        return;
      }

      if (!channelsRef.current[chat.uuid]) {
        console.log(`📡 Подписываемся на канал ${channelName} для обновления списка чатов`);
        const channel = pusherRef.current.subscribe(channelName);
        
        channel.bind('pusher:subscription_succeeded', () => {
          console.log(`✅ Успешно подписались на канал ${channelName}`);
        });
        
        channel.bind('pusher:subscription_error', (error) => {
          console.error(`❌ Ошибка подписки на канал ${channelName}:`, error);
          setError(`Ошибка подписки на канал ${chat.name}: ${error.status || error.message || 'Неизвестная ошибка'}`);
        });
        
        channel.bind('new-message', (message) => {
          console.log('📨 Получено новое сообщение через Pusher (чат не открыт):', message);
          
          // Проверяем, есть ли доступ к этому чату (чат должен быть в списке доступных)
          const hasAccessToChat = chats.some(c => c.uuid === chat.uuid);
          if (!hasAccessToChat) {
            console.log('⚠️ Нет доступа к чату, игнорируем сообщение:', chat.uuid);
            return;
          }
          
          // Обновляем последнее сообщение в списке чатов из пуша
          if (!message.deleted_at) {
            setChats(prevChats => {
              const updatedChats = prevChats.map(c => {
                if (c.uuid === chat.uuid) {
                  return {
                    ...c,
                    last_message_text: message.text || '',
                    last_message_at: message.created_at,
                    last_message_direction: message.direction,
                    updated_at: message.created_at,
                  };
                }
                return c;
              });
              
              // Сортируем чаты по дате последнего сообщения (самые новые сверху)
              updatedChats.sort((a, b) => {
                const dateA = new Date(a.last_message_at || a.updated_at || a.created_at || 0);
                const dateB = new Date(b.last_message_at || b.updated_at || b.created_at || 0);
                return dateB - dateA;
              });
              
              return updatedChats;
            });
          } else {
            // Если сообщение удалено, обновляем список чатов с сервера
            fetchChats();
          }
          
          // Воспроизводим звук уведомления
          playNotificationSound();
          
          // Добавляем в непрочитанные
          if (!message.deleted_at) {
            setUnreadMessages(prev => ({
              ...prev,
              [chat.uuid]: [...(prev[chat.uuid] || []), message],
            }));
          }
        });
        channelsRef.current[chat.uuid] = channel;
      }
    });

    return () => {
      // Очищаем только каналы закрытых чатов
      Object.keys(channelsRef.current).forEach(chatUuid => {
        if (selectedChat && selectedChat.uuid === chatUuid) {
          return; // Не отписываемся от открытого чата
        }
        if (!chats.find(c => c.uuid === chatUuid)) {
          console.log(`📡 Отписываемся от канала private-chat-${chatUuid}`);
          pusherRef.current?.unsubscribe(`private-chat-${chatUuid}`);
          delete channelsRef.current[chatUuid];
        }
      });
    };
  }, [chats, selectedChat?.uuid]);

  useEffect(() => {
    fetchProjects();
    
    // Читаем параметры из URL
    const projectUuid = searchParams.get('project');
    if (projectUuid) {
      setSelectedProjectUuid(projectUuid);
    }
  }, []);

  useEffect(() => {
    if (selectedProjectUuid) {
      fetchChats();
      fetchFolders();
      
      // Обновляем URL с проектом
      const params = new URLSearchParams();
      params.set('project', selectedProjectUuid);
      const chatUuid = searchParams.get('chat');
      const messageId = searchParams.get('message');
      if (chatUuid) {
        params.set('chat', chatUuid);
      }
      if (messageId) {
        params.set('message', messageId);
      }
      navigate(`/messages?${params.toString()}`, { replace: true });
    } else {
      setChats([]);
      setFolders([]);
      setSelectedChat(null);
      setMessages([]);
    }
  }, [selectedProjectUuid]);

  // Обработка выбора чата из URL
  useEffect(() => {
    const chatUuid = searchParams.get('chat');
    const messageId = searchParams.get('message');
    
    if (chatUuid && selectedProjectUuid && chats.length > 0) {
      const chat = chats.find(c => c.uuid === chatUuid);
      if (chat && (!selectedChat || selectedChat.uuid !== chatUuid)) {
        handleSelectChat(chat, messageId);
      } else if (selectedChat && selectedChat.uuid === chatUuid) {
        // Если чат уже выбран, обновляем lastViewedTimes (на случай перезагрузки страницы)
        const now = new Date().toISOString();
        setLastViewedTimes(prev => {
          if (prev[chatUuid] !== now) {
            return {
              ...prev,
              [chatUuid]: now
            };
          }
          return prev;
        });
        setUnreadMessages(prev => {
          const newUnread = { ...prev };
          delete newUnread[chatUuid];
          return newUnread;
        });
        
        if (messageId && messages.length > 0) {
        // Если чат уже выбран, просто прокручиваем к сообщению
        setTimeout(() => {
          const messageElement = document.getElementById(`message-${messageId}`);
          if (messageElement) {
            messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            messageElement.style.backgroundColor = 'rgba(25, 118, 210, 0.1)';
            setTimeout(() => {
              messageElement.style.backgroundColor = '';
            }, 2000);
          }
        }, 200);
      }
    }
    }
  }, [chats, searchParams, selectedChat, messages.length]);

  // Автоматически открываем все папки при загрузке
  useEffect(() => {
    if (folders.length > 0 && Object.keys(expandedFolders).length === 0) {
      const initialExpanded = {};
      folders.forEach(folder => {
        initialExpanded[folder.id] = true;
      });
      setExpandedFolders(initialExpanded);
    }
  }, [folders]);

  // useEffect для загрузки сообщений при изменении selectedChat
  // Убрали отсюда, так как теперь вызывается напрямую в handleSelectChat

  // Обработчик прокрутки для загрузки предыдущих сообщений
  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      // Проверяем, достигли ли верха контейнера
      if (container.scrollTop === 0 && hasMoreMessages && !loadingMoreMessages && messages.length > 0) {
        console.log('Загружаем предыдущие сообщения...');
        const currentOffset = messages.length;
        fetchMessages(selectedChat?.uuid, null, currentOffset);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [hasMoreMessages, loadingMoreMessages, messages.length, selectedChat?.uuid]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const fetchProjects = async () => {
    try {
      const response = await axios.get('/api/projects');
      const fetchedProjects = response.data.projects || [];
      console.log('📁 Загружено проектов:', fetchedProjects.length, 'Проекты:', fetchedProjects.map(p => ({ uuid: p.uuid, name: p.name, status: p.status })));
      setProjects(fetchedProjects);
      
      // Если проект не выбран, но есть проекты, выбираем первый
      if (!selectedProjectUuid && fetchedProjects.length > 0) {
        const firstProject = fetchedProjects[0];
        console.log('📁 Автоматически выбираем первый проект:', firstProject.uuid, firstProject.name);
        setSelectedProjectUuid(firstProject.uuid);
      }
    } catch (err) {
      console.error('Error fetching projects:', err);
    }
  };

  // Загружаем шаблоны при монтировании компонента и при изменении проекта
  useEffect(() => {
    fetchTemplates();
  }, [selectedProjectUuid]);

  const fetchChats = async () => {
    if (!selectedProjectUuid) {
      console.log('⚠️ Проект не выбран, очищаем чаты');
      setChats([]);
      setSelectedChat(null);
      setMessages([]);
      return [];
    }
    try {
      const url = `/api/messages/chats-with-last-message?project_uuid=${selectedProjectUuid}`;
      console.log('📡 Запрос чатов для проекта:', selectedProjectUuid, 'URL:', url);
      const response = await axios.get(url);
      const fetchedChats = response.data.chats || [];
      console.log('✅ Загружено чатов:', fetchedChats.length, 'Чаты:', fetchedChats.map(c => ({ name: c.name, status: c.status, telegram_chat_id: c.telegram_chat_id, folder_id: c.folder_id })));
      console.log('Чаты с folder_id:', fetchedChats.filter(c => c.folder_id).map(c => ({ name: c.name, folder_id: c.folder_id, folder_id_type: typeof c.folder_id })));
      console.log('Чаты без folder_id:', fetchedChats.filter(c => !c.folder_id).map(c => ({ name: c.name, status: c.status })));
      console.log('📊 Полный ответ от сервера:', JSON.stringify(response.data, null, 2));
      setChats(fetchedChats);
      
      // Загружаем счетчики активных задач для всех чатов
      if (fetchedChats.length > 0) {
        const chatUuids = fetchedChats.map(c => c.uuid).join(',');
        try {
          const taskCountsResponse = await axios.get(`/api/tasks/counts-by-chats?chat_uuids=${chatUuids}`);
          setTaskCounts(taskCountsResponse.data.counts || {});
        } catch (err) {
          console.error('Error fetching task counts:', err);
        }
      }
      
      if (selectedChat) {
        const updatedChat = fetchedChats.find(c => c.uuid === selectedChat.uuid);
        if (updatedChat) {
          setSelectedChat(updatedChat);
        } else {
          setSelectedChat(null);
          setMessages([]);
        }
      }
      
      return fetchedChats;
    } catch (err) {
      console.error('Error fetching chats:', err);
      setError('Ошибка загрузки чатов');
      return [];
    }
  };

  const fetchFolders = async () => {
    if (!selectedProjectUuid) {
      setFolders([]);
      return;
    }
    try {
      const response = await axios.get(`/api/folders?project_uuid=${selectedProjectUuid}`);
      const fetchedFolders = response.data.folders || [];
      console.log('Загружено папок:', fetchedFolders.length);
      console.log('Папки:', fetchedFolders.map(f => ({ id: f.id, name: f.name })));
      setFolders(fetchedFolders);
    } catch (err) {
      console.error('Error fetching folders:', err);
      setError('Ошибка загрузки папок');
    }
  };

  const fetchMessages = async (chatUuid, messageIdToScroll = null, offset = 0) => {
    if (!chatUuid) {
      console.error('fetchMessages: chatUuid is missing');
      setLoading(false);
      return;
    }
    try {
      console.log('Fetching messages for chat:', chatUuid, 'offset:', offset);
      if (offset === 0) {
        setLoading(true);
      } else {
        setLoadingMoreMessages(true);
      }
      
      const response = await axios.get(`/api/messages/chat/${chatUuid}`, {
        params: { limit: 30, offset }
      });
      const fetchedMessages = response.data.messages || [];
      console.log('Messages fetched:', fetchedMessages.length);
      
      // Проверяем, есть ли еще сообщения для загрузки
      setHasMoreMessages(fetchedMessages.length === 30);
      
      if (offset === 0) {
        // Первая загрузка - заменяем все сообщения
        setMessages(fetchedMessages);
        
        // Отмечаем все сообщения как прочитанные после загрузки
        const now = new Date().toISOString();
        setLastViewedTimes(prev => ({
          ...prev,
          [chatUuid]: now
        }));
        setUnreadMessages(prev => {
          const newUnread = { ...prev };
          delete newUnread[chatUuid];
          return newUnread;
        });
        
        if (messageIdToScroll) {
          // Прокручиваем к нужному сообщению после загрузки
          setTimeout(() => {
            const messageElement = document.getElementById(`message-${messageIdToScroll}`);
            if (messageElement) {
              messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              messageElement.style.backgroundColor = 'rgba(25, 118, 210, 0.1)';
              setTimeout(() => {
                messageElement.style.backgroundColor = '';
              }, 2000);
            }
          }, 300);
        } else {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
        }
      } else {
        // Загрузка предыдущих сообщений - сохраняем позицию прокрутки
        const container = messagesContainerRef.current;
        const previousScrollHeight = container?.scrollHeight || 0;
        
        setMessages(prev => {
          const newMessages = [...fetchedMessages, ...prev];
          
          // Восстанавливаем позицию прокрутки после обновления DOM
          setTimeout(() => {
            if (container) {
              const newScrollHeight = container.scrollHeight;
              const scrollDifference = newScrollHeight - previousScrollHeight;
              container.scrollTop = scrollDifference;
            }
          }, 0);
          
          return newMessages;
        });
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
      setError('Ошибка загрузки сообщений');
    } finally {
      setLoading(false);
      setLoadingMoreMessages(false);
    }
  };

  const fetchTasks = async (chatUuid) => {
    if (!chatUuid) {
      setTasks([]);
      return;
    }
    try {
      // Загружаем только активные задачи
      const response = await axios.get(`/api/tasks/chat/${chatUuid}?status=pending`);
      setTasks(response.data.tasks || []);
    } catch (err) {
      console.error('Error fetching tasks:', err);
    }
  };

  useEffect(() => {
    if (selectedChat) {
      fetchTasks(selectedChat.uuid);
    } else {
      setTasks([]);
    }
  }, [selectedChat]);

  const handleSelectChat = (chat, messageId = null) => {
    setSelectedChat(chat);
    setMessages([]);
    setHasMoreMessages(false);
    setLoading(true);
    setError('');
    setLastViewedTimes(prev => ({
      ...prev,
      [chat.uuid]: new Date().toISOString()
    }));
    setUnreadMessages(prev => {
      const newUnread = { ...prev };
      delete newUnread[chat.uuid];
      return newUnread;
    });
    
    // Обновляем URL
    const params = new URLSearchParams();
    params.set('project', selectedProjectUuid);
    params.set('chat', chat.uuid);
    if (messageId) {
      params.set('message', messageId);
    }
    navigate(`/messages?${params.toString()}`, { replace: true });
    
    // Загружаем сообщения и задачи сразу
    fetchMessages(chat.uuid, messageId);
    fetchTasks(chat.uuid);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if ((!newMessage.trim() && !selectedFile) || !selectedChat || sending) return;

    const messageText = newMessage.trim();
    setNewMessage('');
    setSending(true);
    setError('');

    const tempMessage = {
      id: `temp-${Date.now()}`,
      chat_id: selectedChat.uuid,
      text: messageText || (selectedFile ? selectedFile.name : ''),
      direction: 'outgoing',
      status: 'sending',
      from_username: user.username,
      created_at: new Date().toISOString(),
    };
    setMessages(prev => [...prev, tempMessage]);

    try {
      const formData = new FormData();
      formData.append('text', messageText || '');
      if (replyToMessage?.id) {
        formData.append('reply_to_message_id', replyToMessage.id);
      }
      if (selectedFile) {
        formData.append('file', selectedFile);
      }

      const response = await axios.post(`/api/messages/chat/${selectedChat.uuid}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setMessages(prev => prev.map(msg => 
        msg.id === tempMessage.id ? response.data.message : msg
      ));

      // Воспроизводим звук отправки при успешной отправке
      playSendSound();

      // Прокручиваем вниз после отправки сообщения
      setTimeout(() => {
        scrollToBottom();
      }, 100);

      setReplyToMessage(null); // Очищаем ответ после отправки
      setSelectedFile(null); // Очищаем выбранный файл
      fetchChats();
    } catch (err) {
      console.error('Error sending message:', err);
      setError(err.response?.data?.error || 'Ошибка отправки сообщения');
      
      setMessages(prev => prev.map(msg => 
        msg.id === tempMessage.id ? { ...msg, status: 'failed' } : msg
      ));
    } finally {
      setSending(false);
    }
  };

  const handleMessageMenuOpen = (event, message) => {
    event.stopPropagation();
    setMessageMenuAnchor(event.currentTarget);
    setSelectedMessageForMenu(message);
  };

  const handleMessageMenuClose = () => {
    setMessageMenuAnchor(null);
    setSelectedMessageForMenu(null);
  };

  const handleReplyToMessage = (message) => {
    setReplyToMessage(message);
    setMessageMenuAnchor(null);
    setSelectedMessageForMenu(null);
  };

  const handleCopyMessageLink = (message) => {
    if (!selectedChat || !selectedProjectUuid) return;
    const url = `${window.location.origin}/messages?project=${selectedProjectUuid}&chat=${selectedChat.uuid}&message=${message.id}`;
    navigator.clipboard.writeText(url);
    setToastMessage('Ссылка на сообщение скопирована');
    setToastOpen(true);
    setMessageMenuAnchor(null);
    setSelectedMessageForMenu(null);
  };

  // Функция для скачивания файла
  const handleDownloadFile = async (messageId, fileName, fileType = null) => {
    if (!selectedChat?.uuid) {
      setError('Чат не выбран');
      return;
    }
    
    // Добавляем messageId в список загружаемых файлов
    setDownloadingFiles(prev => new Set(prev).add(messageId));
    
    try {
      const response = await axios.get(`/api/messages/${selectedChat.uuid}/${messageId}/file`, {
        responseType: 'blob',
      });
      
      // Формируем имя файла с правильным расширением
      let finalFileName = fileName || `file_${messageId}`;
      
      // Для аудио и голосовых сообщений добавляем .mp3, если расширения нет
      if ((fileType === 'audio' || fileType === 'voice') && !finalFileName.match(/\.(mp3|ogg|wav|m4a|oga)$/i)) {
        finalFileName = finalFileName.endsWith('.') 
          ? finalFileName + 'mp3' 
          : finalFileName + '.mp3';
      }
      
      // Создаем blob URL и скачиваем файл
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = finalFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при скачивании файла:', error);
      setError('Не удалось скачать файл');
    } finally {
      // Удаляем messageId из списка загружаемых файлов
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(messageId);
        return newSet;
      });
    }
  };

  // Функция для загрузки аудио файла в blob для воспроизведения
  const loadAudioForPlayback = async (messageId) => {
    if (!selectedChat?.uuid) {
      setError('Чат не выбран');
      return null;
    }

    // Если blob URL уже есть, возвращаем его
    if (audioBlobUrls[messageId]) {
      return audioBlobUrls[messageId];
    }

    // Если уже загружается, ждем
    if (loadingAudio.has(messageId)) {
      return null;
    }

    // Добавляем в список загружаемых
    setLoadingAudio(prev => new Set(prev).add(messageId));

    try {
      const response = await axios.get(`/api/messages/${selectedChat.uuid}/${messageId}/file`, {
        responseType: 'blob',
      });

      // Определяем MIME тип для blob
      // Для голосовых сообщений обычно используется audio/ogg
      let mimeType = response.headers['content-type'] || 'audio/ogg; codecs=opus';
      
      // Если MIME тип не определен или неправильный, используем универсальный
      if (!mimeType || mimeType === 'application/octet-stream') {
        mimeType = 'audio/ogg; codecs=opus';
      }
      
      // Создаем blob URL с правильным MIME типом
      const blob = new Blob([response.data], { type: mimeType });
      const blobUrl = window.URL.createObjectURL(blob);
      
      console.log('✅ Аудио загружено, blob URL создан:', blobUrl, 'MIME type:', mimeType);

      // Сохраняем blob URL
      setAudioBlobUrls(prev => {
        const newUrls = {
          ...prev,
          [messageId]: blobUrl,
        };
        console.log('✅ Blob URL сохранен для сообщения', messageId, 'URLs:', Object.keys(newUrls));
        return newUrls;
      });

      return blobUrl;
    } catch (error) {
      console.error('Ошибка при загрузке аудио для воспроизведения:', error);
      setError('Не удалось загрузить аудио для воспроизведения');
      return null;
    } finally {
      // Удаляем из списка загружаемых
      setLoadingAudio(prev => {
        const newSet = new Set(prev);
        newSet.delete(messageId);
        return newSet;
      });
    }
  };

  // Очищаем blob URLs при смене чата
  useEffect(() => {
    // Освобождаем память от всех blob URLs предыдущего чата
    const urlsToClean = Object.values(audioBlobUrls);
    urlsToClean.forEach(url => {
      window.URL.revokeObjectURL(url);
    });
    setAudioBlobUrls({});
  }, [selectedChat?.uuid]);

  // Инициализируем stickyDate при загрузке сообщений
  useEffect(() => {
    if (messages.length > 0) {
      setStickyDate(messages[0].created_at);
    } else {
      setStickyDate(null);
    }
  }, [messages.length > 0 ? messages[0]?.created_at : null]);

  // Очистка blob URLs при размонтировании компонента
  useEffect(() => {
    return () => {
      // Освобождаем память от всех blob URLs
      Object.values(audioBlobUrls).forEach(url => {
        window.URL.revokeObjectURL(url);
      });
    };
  }, []);

  const handleCreateTaskFromMessage = (message) => {
    // Начинаем режим выбора сообщений
    setSelectedMessagesForTask([message.id]);
    setTaskSelectionMode(true);
    setMessageMenuAnchor(null);
    setSelectedMessageForMenu(null);
  };

  const handleToggleMessageSelection = (messageId) => {
    setSelectedMessagesForTask(prev => {
      if (prev.includes(messageId)) {
        return prev.filter(id => id !== messageId);
      } else {
        return [...prev, messageId];
      }
    });
  };

  const handleOpenCreateTaskDialog = () => {
    if (selectedMessagesForTask.length === 0) {
      setError('Выберите хотя бы одно сообщение');
      return;
    }
    const selectedMessages = messages.filter(m => selectedMessagesForTask.includes(m.id));
    const firstMessage = selectedMessages[0];
    setTaskForm({
      title: selectedMessages.length === 1 
        ? firstMessage.text.substring(0, 100) || ''
        : `Задача из ${selectedMessages.length} сообщений`,
      description: selectedMessages.map(m => m.text).join('\n\n') || '',
      due_date: '',
    });
    setCreateTaskDialogOpen(true);
    setTaskSelectionMode(false);
  };

  const handleCancelTaskSelection = () => {
    setTaskSelectionMode(false);
    setSelectedMessagesForTask([]);
  };

  const handleCreateTask = async () => {
    if (!selectedChat || !taskForm.title.trim()) return;
    try {
      // Отправляем массив message_id
      await axios.post('/api/tasks', {
        chat_uuid: selectedChat.uuid,
        message_ids: selectedMessagesForTask.length > 0 ? selectedMessagesForTask : null,
        title: taskForm.title,
        description: taskForm.description,
        due_date: taskForm.due_date || null,
      });
      setCreateTaskDialogOpen(false);
      setTaskForm({ title: '', description: '', due_date: '' });
      setSelectedMessagesForTask([]);
      fetchTasks(selectedChat.uuid);
      // Обновляем количество задач для чата
      const chatUuids = chats.map(c => c.uuid).join(',');
      if (chatUuids) {
        try {
          const taskCountsResponse = await axios.get(`/api/tasks/counts-by-chats?chat_uuids=${chatUuids}`);
          setTaskCounts(taskCountsResponse.data.counts || {});
        } catch (err) {
          console.error('Error fetching task counts:', err);
        }
      }
      setSuccess('Задача создана');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка создания задачи');
    }
  };

  const handleEditTask = async () => {
    if (!selectedTask || !taskForm.title.trim()) return;
    try {
      await axios.put(`/api/tasks/${selectedTask.id}`, taskForm);
      setEditTaskDialogOpen(false);
      setTaskForm({ title: '', description: '', due_date: '' });
      setSelectedTask(null);
      fetchTasks(selectedChat?.uuid);
      // Обновляем количество задач для чата
      const chatUuids = chats.map(c => c.uuid).join(',');
      if (chatUuids) {
        try {
          const taskCountsResponse = await axios.get(`/api/tasks/counts-by-chats?chat_uuids=${chatUuids}`);
          setTaskCounts(taskCountsResponse.data.counts || {});
        } catch (err) {
          console.error('Error fetching task counts:', err);
        }
      }
      setSuccess('Задача обновлена');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления задачи');
    }
  };

  const handleCompleteTask = async (task) => {
    try {
      await axios.put(`/api/tasks/${task.id}`, {
        status: task.status === 'completed' ? 'pending' : 'completed',
      });
      fetchTasks(selectedChat?.uuid);
      // Обновляем количество задач для чата
      const chatUuids = chats.map(c => c.uuid).join(',');
      if (chatUuids) {
        try {
          const taskCountsResponse = await axios.get(`/api/tasks/counts-by-chats?chat_uuids=${chatUuids}`);
          setTaskCounts(taskCountsResponse.data.counts || {});
        } catch (err) {
          console.error('Error fetching task counts:', err);
        }
      }
      // Обновляем задачу в selectedTaskForView, если она открыта
      if (selectedTaskForView && selectedTaskForView.id === task.id) {
        const newStatus = task.status === 'completed' ? 'pending' : 'completed';
        // Если задача выполнена, закрываем диалог, так как она исчезнет из списка активных
        if (newStatus === 'completed') {
          setViewTaskMessagesDialogOpen(false);
          setSelectedTaskForView(null);
        } else {
          setSelectedTaskForView({
            ...selectedTaskForView,
            status: newStatus || 'pending',
          });
        }
      }
      setSuccess(task.status === 'completed' ? 'Задача отмечена как невыполненная' : 'Задача выполнена');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления задачи');
    }
  };

  const handleDeleteTask = async (task) => {
    if (!window.confirm('Вы уверены, что хотите удалить задачу?')) return;
    try {
      await axios.delete(`/api/tasks/${task.id}`);
      fetchTasks(selectedChat?.uuid);
      // Обновляем количество задач для чата
      const chatUuids = chats.map(c => c.uuid).join(',');
      if (chatUuids) {
        try {
          const taskCountsResponse = await axios.get(`/api/tasks/counts-by-chats?chat_uuids=${chatUuids}`);
          setTaskCounts(taskCountsResponse.data.counts || {});
        } catch (err) {
          console.error('Error fetching task counts:', err);
        }
      }
      // Закрываем диалог, если удаляемая задача открыта
      if (selectedTaskForView && selectedTaskForView.id === task.id) {
        setViewTaskMessagesDialogOpen(false);
        setSelectedTaskForView(null);
      }
      setSuccess('Задача удалена');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка удаления задачи');
    }
  };

  const handleCancelReply = () => {
    setReplyToMessage(null);
  };

  const handleDeleteMessage = async () => {
    if (!selectedMessageForMenu || !selectedChat) return;

    // Проверяем, прошло ли больше 5 минут с момента создания сообщения
    const messageCreatedAt = new Date(selectedMessageForMenu.created_at);
    const now = new Date();
    const diffInMinutes = (now - messageCreatedAt) / (1000 * 60);
    
    if (diffInMinutes > 5) {
      setError('Нельзя удалить сообщение, если прошло больше 5 минут');
      handleMessageMenuClose();
      return;
    }

    try {
      await axios.delete(`/api/messages/${selectedMessageForMenu.id}`);
      // Обновляем список сообщений
      setMessages(prev => prev.filter(m => m.id !== selectedMessageForMenu.id));
      handleMessageMenuClose();
    } catch (err) {
      console.error('Error deleting message:', err);
      const errorMessage = err.response?.data?.error || 'Ошибка удаления сообщения';
      setError(errorMessage);
    }
  };

  const handleEditMessageOpen = () => {
    if (!selectedMessageForMenu) return;

    // Проверяем, прошло ли больше 5 минут с момента создания сообщения
    const messageCreatedAt = new Date(selectedMessageForMenu.created_at);
    const now = new Date();
    const diffInMinutes = (now - messageCreatedAt) / (1000 * 60);
    
    if (diffInMinutes > 5) {
      setError('Нельзя редактировать сообщение, если прошло больше 5 минут');
      handleMessageMenuClose();
      return;
    }

      setEditMessageText(selectedMessageForMenu.text);
      setEditMessageDialogOpen(true);
      handleMessageMenuClose();
  };

  const handleEditMessageClose = () => {
    setEditMessageDialogOpen(false);
    setEditMessageText('');
    setSelectedMessageForMenu(null);
  };

  const handleEditMessage = async () => {
    if (!selectedMessageForMenu || !editMessageText.trim()) return;

    // Проверяем, прошло ли больше 5 минут с момента создания сообщения
    const messageCreatedAt = new Date(selectedMessageForMenu.created_at);
    const now = new Date();
    const diffInMinutes = (now - messageCreatedAt) / (1000 * 60);
    
    if (diffInMinutes > 5) {
      setError('Нельзя редактировать сообщение, если прошло больше 5 минут');
      handleEditMessageClose();
      return;
    }

    try {
      const response = await axios.put(`/api/messages/${selectedMessageForMenu.id}`, {
        text: editMessageText.trim(),
      });
      
      // Обновляем сообщение в списке
      if (response.data && response.data.message) {
        setMessages(prev => prev.map(m => 
          m.id === selectedMessageForMenu.id ? { ...response.data.message } : m
        ));
      }
      
      handleEditMessageClose();
      setSuccess('Сообщение отредактировано');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error editing message:', err);
      const errorMessage = err.response?.data?.error || 'Ошибка редактирования сообщения';
      setError(errorMessage);
    }
  };

  const handleMoveChat = async (folderId) => {
    if (!selectedChatForMenu) return;
    
    try {
      await axios.post(`/api/folders/${folderId || 'null'}/move-chat/${selectedChatForMenu.uuid}`);
      setMoveChatDialogOpen(false);
      setChatMenuAnchor(null);
      setSelectedChatForMenu(null);
      fetchChats();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка перемещения чата');
    }
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => ({
      ...prev,
      [folderId]: !prev[folderId]
    }));
  };

  const fetchTemplates = async () => {
    try {
      const url = selectedProjectUuid 
        ? `/api/templates?project_uuid=${selectedProjectUuid}`
        : '/api/templates';
      const response = await axios.get(url);
      setTemplates(response.data.templates || []);
    } catch (err) {
      console.error('Error fetching templates:', err);
    }
  };

  const handleCreateTemplate = async () => {
    if (!templateForm.name.trim() || !templateForm.text.trim()) {
      setError('Заполните название и текст шаблона');
      return;
    }

    if (!selectedProjectUuid && !selectedTemplateForEdit) {
      setError('Выберите проект для создания шаблона');
      return;
    }

    try {
      if (selectedTemplateForEdit) {
        // Редактирование
        await axios.put(`/api/templates/${selectedTemplateForEdit.id}`, templateForm);
        setSuccess('Шаблон обновлен');
      } else {
        // Создание
        await axios.post('/api/templates', {
          ...templateForm,
          project_uuid: selectedProjectUuid
        });
        setSuccess('Шаблон создан');
      }
      setTemplateForm({ name: '', text: '' });
      setSelectedTemplateForEdit(null);
      setTemplateFormOpen(false);
      fetchTemplates();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error saving template:', err);
      setError(err.response?.data?.error || 'Ошибка сохранения шаблона');
    }
  };

  const handleDeleteTemplate = async () => {
    if (!selectedTemplateForMenu) return;

    if (!window.confirm('Вы уверены, что хотите удалить этот шаблон?')) return;

    try {
      await axios.delete(`/api/templates/${selectedTemplateForMenu.id}`);
      setSuccess('Шаблон удален');
      setTemplateMenuAnchor(null);
      setSelectedTemplateForMenu(null);
      fetchTemplates();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error deleting template:', err);
      setError(err.response?.data?.error || 'Ошибка удаления шаблона');
    }
  };

  const handleEditTemplate = () => {
    if (selectedTemplateForMenu) {
      setTemplateForm({
        name: selectedTemplateForMenu.name,
        text: selectedTemplateForMenu.text,
      });
      setSelectedTemplateForEdit(selectedTemplateForMenu);
      setTemplateFormOpen(true);
      setTemplateMenuAnchor(null);
      setSelectedTemplateForMenu(null);
    }
  };

  const handleSelectTemplate = (template) => {
    setNewMessage(template.text);
    setTemplatesDialogOpen(false);
  };

  const handleTemplateMenuOpen = (event, template) => {
    event.stopPropagation();
    setTemplateMenuAnchor(event.currentTarget);
    setSelectedTemplateForMenu(template);
  };

  const handleTemplateMenuClose = () => {
    setTemplateMenuAnchor(null);
    setSelectedTemplateForMenu(null);
  };

  const formatMessageText = (text) => {
    if (!text) return '';
    
    // Разбиваем текст на строки по 70 символов
    const lines = [];
    let currentLine = '';
    
    // Разбиваем по словам, чтобы не разрывать слова
    const words = text.split(/\s+/);
    
    for (const word of words) {
      // Если слово само по себе длиннее 70 символов, разбиваем его
      if (word.length > 70) {
        if (currentLine) {
          lines.push(currentLine.trim());
          currentLine = '';
        }
        // Разбиваем длинное слово по 70 символов
        for (let i = 0; i < word.length; i += 70) {
          lines.push(word.substring(i, i + 70));
        }
      } else {
        // Проверяем, поместится ли слово в текущую строку
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        if (testLine.length <= 70) {
          currentLine = testLine;
        } else {
          if (currentLine) {
            lines.push(currentLine.trim());
          }
          currentLine = word;
        }
      }
    }
    
    if (currentLine) {
      lines.push(currentLine.trim());
    }
    
    return lines.join('\n');
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    // Сбрасываем время для сравнения дат
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
    
    if (dateOnly.getTime() === todayOnly.getTime()) {
      return 'Сегодня';
    } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
      return 'Вчера';
    } else {
      return date.toLocaleDateString('ru-RU', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      });
    }
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    
    // Получаем временную зону пользователя из браузера
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Опции форматирования с учетом временной зоны пользователя
    const timeOptions = {
      timeZone: userTimezone,
      hour: '2-digit',
      minute: '2-digit',
    };
    
    const dateTimeOptions = {
      timeZone: userTimezone,
      day: '2-digit',
      month: '2-digit',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
      hour: '2-digit',
      minute: '2-digit',
    };
    
    if (minutes < 1) return 'только что';
    if (minutes < 60) return `${minutes} мин назад`;
    if (diff < 86400000) {
      // Сегодня - показываем только время
      return date.toLocaleTimeString('ru-RU', timeOptions);
    }
    // Больше суток - показываем дату и время
    return date.toLocaleString('ru-RU', dateTimeOptions);
  };

  // Группировка чатов по папкам
  const chatsByFolder = chats.reduce((acc, chat) => {
    const folderId = chat.folder_id ? String(chat.folder_id) : 'no-folder';
    if (!acc[folderId]) {
      acc[folderId] = [];
    }
    acc[folderId].push(chat);
    return acc;
  }, {});

  const noFolderChats = chatsByFolder['no-folder'] || [];
  const folderChats = Object.entries(chatsByFolder).filter(([id]) => id !== 'no-folder');
  
  // Логирование для отладки
  console.log('📂 Группировка чатов - Всего чатов:', chats.length);
  console.log('📂 Чаты по папкам:', Object.keys(chatsByFolder).map(key => ({ folderId: key, count: chatsByFolder[key].length })));
  console.log('📂 Чаты без папки:', noFolderChats.length, noFolderChats.map(c => ({ name: c.name, folder_id: c.folder_id })));
  console.log('📂 Чаты с папками:', folderChats.length, folderChats.map(([id, folderChatsList]) => ({ folderId: id, chats: folderChatsList.map(c => c.name) })));
  
  // Функция для подсчета непрочитанных сообщений в папке
  const getFolderUnreadCount = (folderId) => {
    const folderChatsList = chats.filter(chat => {
      const chatFolderId = chat.folder_id ? Number(chat.folder_id) : null;
      const folderIdNum = Number(folderId);
      return chatFolderId === folderIdNum;
    });
    
    let totalUnread = 0;
    folderChatsList.forEach(chat => {
      const lastViewedTime = lastViewedTimes[chat.uuid];
      const unreadCount = unreadMessages[chat.uuid]?.length || 0;
      const hasNewMessages = (chat.last_message_at && 
        (!lastViewedTime || new Date(chat.last_message_at) > new Date(lastViewedTime)) &&
        selectedChat?.uuid !== chat.uuid) || unreadCount > 0;
      
      if (hasNewMessages) {
        totalUnread += unreadCount || 1;
      }
    });
    
    return totalUnread;
  };
  
  // Функция для проверки, есть ли новые сообщения в папке
  const hasFolderNewMessages = (folderId) => {
    return getFolderUnreadCount(folderId) > 0;
  };
  
  // Функция для проверки, есть ли непрочитанные сообщения в чате
  const hasUnreadMessages = (chat) => {
    // Если чат выбран, всегда возвращаем false
    if (selectedChat?.uuid === chat.uuid) {
      return false;
    }
    const lastViewedTime = lastViewedTimes[chat.uuid];
    const unreadCount = unreadMessages[chat.uuid]?.length || 0;
    // Если есть непрочитанные сообщения в массиве, возвращаем true
    if (unreadCount > 0) {
      return true;
    }
    // Проверяем, есть ли новые сообщения после последнего просмотра
    if (chat.last_message_at && lastViewedTime) {
      return new Date(chat.last_message_at) > new Date(lastViewedTime);
    }
    // Если нет lastViewedTime, но есть last_message_at, считаем что есть непрочитанные
    return !!chat.last_message_at;
  };
  
  // Функция для получения количества непрочитанных сообщений в чате
  const getChatUnreadCount = (chat) => {
    // Если чат выбран, всегда возвращаем 0
    if (selectedChat?.uuid === chat.uuid) {
      return 0;
    }
    const unreadCount = unreadMessages[chat.uuid]?.length || 0;
    if (unreadCount > 0) return unreadCount;
    const lastViewedTime = lastViewedTimes[chat.uuid];
    if (chat.last_message_at && 
        (!lastViewedTime || new Date(chat.last_message_at) > new Date(lastViewedTime))) {
      return 1; // Есть новое сообщение, но точное количество неизвестно
    }
    return 0;
  };
  
  // Сортируем папки: сначала с новыми сообщениями, потом по количеству чатов
  folderChats.sort((a, b) => {
    const aHasNew = hasFolderNewMessages(parseInt(a[0]));
    const bHasNew = hasFolderNewMessages(parseInt(b[0]));
    if (aHasNew && !bHasNew) return -1;
    if (!aHasNew && bHasNew) return 1;
    return b[1].length - a[1].length;
  });

  return (
    <Layout>
      <Container maxWidth="xl" sx={{ height: 'calc(100vh - 64px)', py: 2 }}>
        <Box sx={{ display: 'flex', height: '100%', gap: 2 }}>
          {/* Панель чатов */}
          <Paper sx={{ width: 350, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Сообщения</Typography>
                {selectedProjectUuid && (
                  <IconButton
                    size="small"
                    onClick={() => setShowUnreadOnly(!showUnreadOnly)}
                    color={showUnreadOnly ? 'primary' : 'default'}
                    title={showUnreadOnly ? 'Показать все чаты' : 'Показать только непрочитанные'}
                  >
                    <FilterListIcon />
                  </IconButton>
                )}
              </Box>
              {projects.length > 0 ? (
                <FormControl fullWidth size="medium" required>
                  <InputLabel>Выберите проект</InputLabel>
                  <Select
                    value={selectedProjectUuid || ''}
                    onChange={(e) => {
                      setSelectedProjectUuid(e.target.value);
                      setSelectedChat(null);
                      setMessages([]);
                      setShowUnreadOnly(false);
                    }}
                    label="Выберите проект"
                  >
                    {projects.map(project => (
                      <MenuItem key={project.uuid} value={project.uuid}>{project.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <Alert severity="info">
                  Нет доступных проектов. Создайте проект или попросите добавить вас в проект.
                </Alert>
              )}
            </Box>
            <List sx={{ flex: 1, overflow: 'auto', p: 0 }}>
              {!selectedProjectUuid ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <ChatIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                    Выберите проект для просмотра чатов
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Выберите проект из списка выше, чтобы увидеть доступные чаты
                  </Typography>
                </Box>
              ) : chats.length === 0 ? (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <ChatIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    Нет подключенных чатов в этом проекте
                  </Typography>
                </Box>
              ) : (
                <>
                  {/* Чаты в папках */}
                  {folders.length > 0 && folders.map((folder) => {
                    // Фильтруем чаты по folder_id (может быть число или строка)
                    // Преобразуем оба значения в числа для сравнения
                    let folderChatsList = chats.filter(chat => {
                      const chatFolderId = chat.folder_id ? Number(chat.folder_id) : null;
                      const folderId = Number(folder.id);
                      const matches = chatFolderId === folderId;
                      if (matches) {
                        console.log(`Чат "${chat.name}" (folder_id: ${chat.folder_id}) соответствует папке "${folder.name}" (id: ${folder.id})`);
                      }
                      return matches;
                    });
                    
                    console.log(`Папка "${folder.name}" (id: ${folder.id}): найдено чатов: ${folderChatsList.length}`);
                    
                    // Применяем фильтр "Не прочитанное"
                    if (showUnreadOnly) {
                      folderChatsList = folderChatsList.filter(chat => hasUnreadMessages(chat));
                    }
                    
                    // Показываем папку только если в ней есть чаты
                    if (folderChatsList.length === 0) return null;
                    const isExpanded = expandedFolders[folder.id] !== false;
                    const folderUnreadCount = getFolderUnreadCount(folder.id);
                    const hasNewMessages = hasFolderNewMessages(folder.id);
                    
                    return (
                      <React.Fragment key={folder.id}>
                        <ListItem
                          button
                          onClick={() => toggleFolder(folder.id)}
                          sx={{ 
                            borderBottom: 1, 
                            borderColor: 'divider',
                            backgroundColor: hasNewMessages ? 'action.hover' : 'transparent',
                          }}
                        >
                          {(() => {
                            const FolderIconComponent = getIconComponent(folder.icon);
                            return <FolderIconComponent sx={{ mr: 1, color: folder.color || 'text.secondary' }} />;
                          })()}
                          <ListItemText
                            primary={
                              <Typography variant="subtitle2" sx={{ fontWeight: hasNewMessages ? 600 : 400 }}>
                                {folder.name}
                              </Typography>
                            }
                            secondary={`${folderChatsList.length} чатов`}
                          />
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Badge
                              color="error"
                              badgeContent={folderUnreadCount > 0 ? folderUnreadCount : 0}
                              invisible={!hasNewMessages}
                            />
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </Box>
                        </ListItem>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          {folderChatsList.map((chat) => {
                            const hasNewMessages = hasUnreadMessages(chat);
                            const unreadCount = getChatUnreadCount(chat);

                            return (
                              <ListItem
                                key={chat.uuid}
                                button
                                selected={selectedChat?.uuid === chat.uuid}
                                onClick={() => handleSelectChat(chat)}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  setChatMenuAnchor(e.currentTarget);
                                  setSelectedChatForMenu(chat);
                                }}
                                sx={{
                                  pl: 4,
                                  borderBottom: 1,
                                  borderColor: 'divider',
                                  backgroundColor: hasNewMessages && selectedChat?.uuid !== chat.uuid 
                                    ? 'action.hover' 
                                    : 'transparent',
                                  '&.Mui-selected': {
                                    backgroundColor: 'primary.light',
                                  },
                                }}
                              >
                                <Avatar 
                                  src={chat.icon_url} 
                                  sx={{ mr: 2, bgcolor: 'primary.main' }}
                                >
                                  {!chat.icon_url && <ChatIcon />}
                                </Avatar>
                                <ListItemText
                                  primary={
                                    <Typography 
                                      component="div" 
                                      sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                    >
                                      <Typography 
                                        variant="subtitle2" 
                                        component="span"
                                        sx={{ fontWeight: hasNewMessages && selectedChat?.uuid !== chat.uuid ? 600 : 400 }}
                                      >
                                        {chat.name}
                                      </Typography>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {taskCounts[chat.uuid] > 0 && (
                                          <Chip
                                            label={taskCounts[chat.uuid]}
                                            size="small"
                                            color="warning"
                                            sx={{ height: 20, fontSize: '0.7rem' }}
                                          />
                                        )}
                                      <Badge
                                        color="error"
                                        badgeContent={unreadCount > 0 ? unreadCount : 0}
                                        invisible={!hasNewMessages || selectedChat?.uuid === chat.uuid}
                                      />
                                      </Box>
                                    </Typography>
                                  }
                                  secondary={
                                    <>
                                      {chat.last_message_text ? (
                                        <>
                                          <Typography variant="body2" component="div" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200, fontWeight: hasNewMessages && selectedChat?.uuid !== chat.uuid ? 500 : 400 }}>
                                            {chat.last_message_direction === 'outgoing' && 'Вы: '}
                                            {chat.last_message_text}
                                          </Typography>
                                          <Typography variant="caption" component="div" color="text.secondary">
                                            {formatTime(chat.last_message_at)}
                                          </Typography>
                                        </>
                                      ) : (
                                        <Typography variant="caption" component="div" color="text.secondary">
                                          Нет сообщений
                                        </Typography>
                                      )}
                                    </>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                        </Collapse>
                      </React.Fragment>
                    );
                  })}
                  
                  {/* Чаты без папки */}
                  {(() => {
                    let filteredNoFolderChats = noFolderChats;
                    if (showUnreadOnly) {
                      filteredNoFolderChats = noFolderChats.filter(chat => hasUnreadMessages(chat));
                    }
                    if (filteredNoFolderChats.length === 0) return null;
                    
                    return (
                      <>
                        <ListItem sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.100' }}>
                          <Typography variant="caption" color="text.secondary">
                            Без папки
                          </Typography>
                        </ListItem>
                        {filteredNoFolderChats.map((chat) => {
                          const hasNewMessages = hasUnreadMessages(chat);
                          const unreadCount = getChatUnreadCount(chat);

                          return (
                          <ListItem
                            key={chat.uuid}
                            button
                            selected={selectedChat?.uuid === chat.uuid}
                            onClick={() => handleSelectChat(chat)}
                            onContextMenu={(e) => {
                              e.preventDefault();
                              setChatMenuAnchor(e.currentTarget);
                              setSelectedChatForMenu(chat);
                            }}
                            sx={{
                              borderBottom: 1,
                              borderColor: 'divider',
                              backgroundColor: hasNewMessages && selectedChat?.uuid !== chat.uuid 
                                ? 'action.hover' 
                                : 'transparent',
                              '&.Mui-selected': {
                                backgroundColor: 'primary.light',
                              },
                            }}
                          >
                            <Avatar 
                              src={chat.icon_url} 
                              sx={{ mr: 2, bgcolor: 'primary.main' }}
                            >
                              {!chat.icon_url && <ChatIcon />}
                            </Avatar>
                            <ListItemText
                              primary={
                                <Typography 
                                  component="div" 
                                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                  <Typography 
                                    variant="subtitle2" 
                                    component="span"
                                    sx={{ fontWeight: hasNewMessages && selectedChat?.uuid !== chat.uuid ? 600 : 400 }}
                                  >
                                    {chat.name}
                                  </Typography>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {taskCounts[chat.uuid] > 0 && (
                                      <Chip
                                        label={taskCounts[chat.uuid]}
                                        size="small"
                                        color="warning"
                                        sx={{ height: 20, fontSize: '0.7rem' }}
                                      />
                                    )}
                                  <Badge
                                    color="error"
                                    badgeContent={unreadCount > 0 ? unreadCount : 0}
                                    invisible={!hasNewMessages || selectedChat?.uuid === chat.uuid}
                                  />
                                  </Box>
                                </Typography>
                              }
                              secondary={
                                <>
                                  {chat.last_message_text ? (
                                    <>
                                      <Typography variant="body2" component="div" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200, fontWeight: hasNewMessages && selectedChat?.uuid !== chat.uuid ? 500 : 400 }}>
                                        {chat.last_message_direction === 'outgoing' && 'Вы: '}
                                        {chat.last_message_text}
                                      </Typography>
                                      <Typography variant="caption" component="div" color="text.secondary">
                                        {formatTime(chat.last_message_at)}
                                      </Typography>
                                    </>
                                  ) : (
                                    <Typography variant="caption" component="div" color="text.secondary">
                                      Нет сообщений
                                    </Typography>
                                  )}
                                </>
                              }
                            />
                          </ListItem>
                        );
                      })}
                    </>
                  );
                  })()}
                </>
              )}
            </List>
          </Paper>

          {/* Окно сообщений */}
          <Paper sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {selectedChat ? (
              <>
                <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">{selectedChat.name}</Typography>
                    {selectedChat.description && (
                      <Typography variant="body2" color="text.secondary">
                        {selectedChat.description}
                      </Typography>
                    )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {selectedChat.folder_name && (() => {
                      const folder = folders.find(f => f.name === selectedChat.folder_name);
                      const FolderIconComponent = folder ? getIconComponent(folder.icon) : FolderIcon;
                        return (
                          <Chip 
                            icon={<FolderIconComponent />} 
                            label={selectedChat.folder_name} 
                            size="small" 
                            sx={{ height: 28 }}
                          />
                        );
                    })()}
                  <IconButton
                    size="small"
                    onClick={() => {
                      const url = `${window.location.origin}/messages?project=${selectedProjectUuid}&chat=${selectedChat.uuid}`;
                      navigator.clipboard.writeText(url);
                      setSuccess('Ссылка на чат скопирована');
                      setTimeout(() => setSuccess(''), 3000);
                    }}
                    title="Скопировать ссылку на чат"
                  >
                    <ShareIcon />
                  </IconButton>
                    </Box>
                  </Box>
                  
                  {/* Компактное отображение задач */}
                  {tasks.length > 0 && (() => {
                    // Показываем только активные задачи
                    const activeTasks = tasks.filter(t => t.status !== 'completed');
                    
                    if (activeTasks.length === 0) {
                      return null;
                    }
                    
                    return (
                      <Box sx={{ mt: 1, pt: 1, borderTop: 1, borderColor: 'divider' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <TaskIcon fontSize="small" />
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>
                              Задачи:
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', flex: 1 }}>
                            {activeTasks.slice(0, 5).map((task) => {
                              const truncatedTitle = task.title.length > 50 
                                ? task.title.substring(0, 50) + '...' 
                                : task.title;
                              
                              // Убеждаемся, что статус определен
                              const taskStatus = task.status || 'pending';
                              
                              return (
                                <Chip
                                  key={task.id}
                                  label={truncatedTitle}
                                  size="small"
                                  color="primary"
                                  sx={{ 
                                    fontSize: '0.7rem',
                                    height: 24,
                                    cursor: 'pointer',
                                    '&:hover': { opacity: 0.8 }
                                  }}
                                  onClick={() => {
                                    setSelectedTaskForView(task);
                                    setViewTaskMessagesDialogOpen(true);
                                  }}
                                />
                              );
                            })}
                            {activeTasks.length > 5 && (
                              <Chip
                                label={`+${activeTasks.length - 5}`}
                                size="small"
                                sx={{ fontSize: '0.7rem', height: 24 }}
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })()}
                </Box>

                {error && (
                  <Alert severity="error" sx={{ m: 2 }} onClose={() => setError('')}>
                    {error}
                  </Alert>
                )}

                {success && (
                  <Alert severity="success" sx={{ m: 2 }} onClose={() => setSuccess('')}>
                    {success}
                  </Alert>
                )}

                <Box
                  ref={messagesContainerRef}
                  sx={{
                    flex: 1,
                    overflow: 'auto',
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    position: 'relative',
                  }}
                  onScroll={(e) => {
                    // Определяем первое видимое сообщение при прокрутке
                    const container = e.target;
                    const scrollTop = container.scrollTop;
                    
                    // Если мы в самом верху (scrollTop < 50), не показываем sticky дату
                    if (scrollTop < 50) {
                      setStickyDate(null);
                      return;
                    }
                    
                    // Находим первое сообщение, которое видно в верхней части контейнера
                    let firstVisibleMessage = null;
                    for (let i = 0; i < messages.length; i++) {
                      const messageElement = document.getElementById(`message-${messages[i].id}`);
                      if (messageElement) {
                        const messageRect = messageElement.getBoundingClientRect();
                        const containerRect = container.getBoundingClientRect();
                        
                        // Проверяем, видно ли сообщение в верхней части контейнера (с отступом 60px для sticky header)
                        if (messageRect.top <= containerRect.top + 60 && messageRect.bottom > containerRect.top) {
                          firstVisibleMessage = messages[i];
                          break;
                        }
                      }
                    }
                    
                    // Если не нашли, берем первое сообщение, которое находится выше верхней границы
                    if (!firstVisibleMessage) {
                      for (let i = messages.length - 1; i >= 0; i--) {
                        const messageElement = document.getElementById(`message-${messages[i].id}`);
                        if (messageElement) {
                          const messageRect = messageElement.getBoundingClientRect();
                          const containerRect = container.getBoundingClientRect();
                          if (messageRect.top <= containerRect.top + 100) {
                            firstVisibleMessage = messages[i];
                            break;
                          }
                        }
                      }
                    }
                    
                    // Устанавливаем дату для sticky header
                    if (firstVisibleMessage) {
                      setStickyDate(firstVisibleMessage.created_at);
                    } else if (messages.length > 0) {
                      setStickyDate(messages[0].created_at);
                    }
                  }}
                >
                  {/* Sticky дата сверху */}
                  {stickyDate && (
                    <Box
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        py: 1,
                        mb: 1,
                        pointerEvents: 'none', // Не блокируем клики на сообщения
                        width: '100%',
                        background: 'transparent', // Прозрачный фон, чтобы не перекрывать текст
                      }}
                    >
                      <Chip
                        label={formatDate(stickyDate)}
                        size="small"
                        sx={{
                          bgcolor: 'transparent', // Прозрачный фон
                          border: '1px solid',
                          borderColor: 'divider',
                          fontWeight: 500,
                          pointerEvents: 'auto', // Разрешаем клики на сам Chip
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Легкая тень для видимости
                          color: 'text.primary',
                        }}
                      />
                    </Box>
                  )}
                  {loading && messages.length === 0 ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                      <CircularProgress />
                    </Box>
                  ) : messages.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body1" color="text.secondary">
                        Нет сообщений. Начните переписку!
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {loadingMoreMessages && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                          <CircularProgress size={24} />
                        </Box>
                      )}
                      {messages.map((message, index) => {
                        // Определяем, нужно ли показывать заголовок с датой
                        const showDateHeader = index === 0 || (() => {
                          const currentDate = new Date(message.created_at);
                          const prevDate = new Date(messages[index - 1].created_at);
                          const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                          const prevDateOnly = new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate());
                          return currentDateOnly.getTime() !== prevDateOnly.getTime();
                        })();

                        return (
                          <React.Fragment key={message.id}>
                            {showDateHeader && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  my: 2,
                                }}
                              >
                                <Chip
                                  label={formatDate(message.created_at)}
                                  size="small"
                                  sx={{
                                    bgcolor: 'background.paper',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    fontWeight: 500,
                                  }}
                                />
                              </Box>
                            )}
                            <Box
                        id={`message-${message.id}`}
                        sx={{
                          display: 'flex',
                          justifyContent: message.direction === 'outgoing' ? 'flex-end' : 'flex-start',
                          mb: 1,
                                alignItems: 'flex-start',
                                gap: 1,
                              }}
                            >
                              {taskSelectionMode && (
                                <Checkbox
                                  checked={selectedMessagesForTask.includes(message.id)}
                                  onChange={() => handleToggleMessageSelection(message.id)}
                                  size="small"
                                  sx={{ mt: 0.5 }}
                                />
                              )}
                        <Box
                          sx={{
                                  maxWidth: taskSelectionMode ? '65%' : '70%',
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: message.direction === 'outgoing' 
                              ? 'primary.main' 
                              : isDarkMode 
                                ? '#1e1e1e' 
                                : 'grey.200',
                            color: message.direction === 'outgoing' 
                              ? 'white' 
                              : isDarkMode 
                                ? 'white' 
                                : 'text.primary',
                                  border: taskSelectionMode && selectedMessagesForTask.includes(message.id) 
                                    ? '2px solid' 
                                    : 'none',
                                  borderColor: taskSelectionMode && selectedMessagesForTask.includes(message.id)
                                    ? 'primary.main'
                                    : 'transparent',
                                }}
                        >
                          {message.reply_to_message_id && message.reply_to_text && (
                            <Box
                              sx={{
                                mb: 1,
                                pl: 1,
                                borderLeft: 2,
                                borderColor: message.direction === 'outgoing' ? 'rgba(255,255,255,0.5)' : 'primary.main',
                                opacity: 0.8,
                              }}
                            >
                              <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, mb: 0.5 }}>
                                Ответ на сообщение
                              </Typography>
                              <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%', fontSize: '0.75rem' }}>
                                {message.reply_to_text}
                              </Typography>
                            </Box>
                          )}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
                            <Typography variant="caption" sx={{ opacity: 0.8 }}>
                              {message.direction === 'outgoing' 
                                ? user?.username || 'Вы'
                                : message.from_first_name || 'Неизвестный'}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={(e) => handleMessageMenuOpen(e, message)}
                              sx={{ opacity: 0.6, '&:hover': { opacity: 1 } }}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </Box>
                          {message.text && (
                          <Typography 
                            variant="body1" 
                            sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                          >
                            {formatMessageText(message.text)}
                          </Typography>
                          )}
                          
                          {/* Отображение файлов */}
                          {message.file_type && (
                            <Box sx={{ mt: message.text ? 1 : 0 }}>
                              {message.file_type === 'photo' && (
                                <Box sx={{ mb: 1 }}>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      minHeight: '100px',
                                      bgcolor: message.direction === 'outgoing' 
                                        ? 'rgba(255,255,255,0.1)' 
                                        : isDarkMode 
                                          ? '#2a2a2a' 
                                          : 'grey.100',
                                      borderRadius: '8px',
                                      p: 2,
                                      cursor: 'pointer',
                                      '&:hover': {
                                        bgcolor: message.direction === 'outgoing' 
                                          ? 'rgba(255,255,255,0.15)' 
                                          : isDarkMode 
                                            ? '#333333' 
                                            : 'grey.200',
                                      },
                                    }}
                                    onClick={() => {
                                      if (selectedChat?.uuid) {
                                        window.open(getFileUrl(selectedChat.uuid, message.id), '_blank');
                                      }
                                    }}
                                  >
                                    <ImageIcon sx={{ fontSize: 48, opacity: 0.6 }} />
                                    {message.file_name && (
                                      <Typography variant="caption" sx={{ ml: 1, opacity: 0.8 }}>
                                        {message.file_name}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Button
                                    size="small"
                                    startIcon={downloadingFiles.has(message.id) ? <CircularProgress size={16} /> : <DownloadIcon />}
                                    onClick={() => handleDownloadFile(message.id, message.file_name || `photo_${message.id}.jpg`)}
                                    disabled={downloadingFiles.has(message.id)}
                                    sx={{ mt: 0.5 }}
                                  >
                                    {downloadingFiles.has(message.id) ? 'Скачивание...' : 'Скачать фото'}
                                  </Button>
                                </Box>
                              )}
                              {message.file_type === 'document' && (
                                <Paper
                                  sx={{
                                    p: 1.5,
                                    bgcolor: message.direction === 'outgoing' 
                                      ? 'rgba(255,255,255,0.2)' 
                                      : isDarkMode 
                                        ? '#2a2a2a' 
                                        : 'grey.100',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    mb: 1,
                                  }}
                                >
                                  <AttachFileIcon />
                                  <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      {message.file_name || 'Документ'}
                                    </Typography>
                                    {message.file_size && (
                                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                        {(message.file_size / 1024).toFixed(1)} KB
                                      </Typography>
                                    )}
                                  </Box>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDownloadFile(message.id, message.file_name || `file_${message.id}`)}
                                    disabled={downloadingFiles.has(message.id)}
                                  >
                                    {downloadingFiles.has(message.id) ? (
                                      <CircularProgress size={20} />
                                    ) : (
                                      <DownloadIcon />
                                    )}
                                  </IconButton>
                                </Paper>
                              )}
                              {message.file_type === 'video' && (
                                <Box sx={{ mb: 1 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                    <VideoFileIcon />
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {message.file_name || 'Видео'}
                                    </Typography>
                                    {message.file_size && (
                                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                        {(message.file_size / 1024 / 1024).toFixed(1)} MB
                                      </Typography>
                                    )}
                                  </Box>
                                  <Button
                                    size="small"
                                    startIcon={downloadingFiles.has(message.id) ? <CircularProgress size={16} /> : <DownloadIcon />}
                                    onClick={() => handleDownloadFile(message.id, message.file_name || `video_${message.id}`)}
                                    disabled={downloadingFiles.has(message.id)}
                                  >
                                    {downloadingFiles.has(message.id) ? 'Скачивание...' : 'Скачать видео'}
                                  </Button>
                                </Box>
                              )}
                              {(message.file_type === 'audio' || message.file_type === 'voice') && (
                                <Box sx={{ mb: 1 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                    <AudioFileIcon />
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {message.file_name || (message.file_type === 'voice' ? 'Голосовое сообщение' : 'Аудио')}
                                    </Typography>
                                    {message.file_size && (
                                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                        {(message.file_size / 1024).toFixed(1)} KB
                                      </Typography>
                                    )}
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    {loadingAudio.has(message.id) ? (
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: '200px' }}>
                                        <CircularProgress size={20} />
                                        <Typography variant="caption">Загрузка аудио...</Typography>
                                      </Box>
                                    ) : (
                                      <audio
                                        key={`audio-${message.id}-${audioBlobUrls[message.id] ? 'loaded' : 'empty'}`}
                                        ref={playingAudioId === message.id ? audioPlayerRef : null}
                                        src={audioBlobUrls[message.id] || undefined}
                                        controls
                                        style={{
                                          maxWidth: '100%',
                                          height: '32px',
                                          flex: 1,
                                          minWidth: '200px',
                                        }}
                                        onPlay={async (e) => {
                                          // Останавливаем другие аудио при воспроизведении нового
                                          if (audioPlayerRef.current && playingAudioId !== message.id) {
                                            audioPlayerRef.current.pause();
                                          }

                                          // Если blob URL еще не загружен, загружаем его перед воспроизведением
                                          if (!audioBlobUrls[message.id] && !loadingAudio.has(message.id)) {
                                            e.preventDefault();
                                            e.target.pause();
                                            
                                            const blobUrl = await loadAudioForPlayback(message.id);
                                            if (blobUrl && e.target) {
                                              console.log('✅ Blob URL получен, обновляем src аудио элемента');
                                              // Обновляем src и воспроизводим
                                              e.target.src = blobUrl;
                                              e.target.load();
                                              // Небольшая задержка перед воспроизведением
                                              setTimeout(() => {
                                                e.target.play().catch(err => {
                                                  console.error('❌ Ошибка воспроизведения:', err);
                                                  setError('Не удалось воспроизвести аудио: ' + (err.message || 'Неизвестная ошибка'));
                                                });
                                              }, 200);
                                            } else {
                                              console.error('❌ Не удалось получить blob URL');
                                              setError('Не удалось загрузить аудио');
                                            }
                                            return;
                                          }

                                          setPlayingAudioId(message.id);
                                        }}
                                        onEnded={() => setPlayingAudioId(null)}
                                        onPause={() => {
                                          if (playingAudioId === message.id) {
                                            setPlayingAudioId(null);
                                          }
                                        }}
                                        onError={(e) => {
                                          console.error('Ошибка воспроизведения аудио:', e);
                                          setError('Ошибка воспроизведения аудио файла');
                                          setPlayingAudioId(null);
                                          // Очищаем blob URL при ошибке
                                          if (audioBlobUrls[message.id]) {
                                            window.URL.revokeObjectURL(audioBlobUrls[message.id]);
                                            setAudioBlobUrls(prev => {
                                              const newUrls = { ...prev };
                                              delete newUrls[message.id];
                                              return newUrls;
                                            });
                                          }
                                        }}
                                        onLoadedData={() => {
                                          // Файл загружен и готов к воспроизведению
                                          if (loadingAudio.has(message.id)) {
                                            setLoadingAudio(prev => {
                                              const newSet = new Set(prev);
                                              newSet.delete(message.id);
                                              return newSet;
                                            });
                                          }
                                        }}
                                      />
                                    )}
                                    <Button
                                      size="small"
                                      startIcon={downloadingFiles.has(message.id) ? <CircularProgress size={16} /> : <DownloadIcon />}
                                      onClick={() => handleDownloadFile(message.id, message.file_name || `audio_${message.id}`, message.file_type)}
                                      disabled={downloadingFiles.has(message.id)}
                                      variant="outlined"
                                    >
                                      {downloadingFiles.has(message.id) ? 'Скачивание...' : 'Скачать'}
                                    </Button>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          )}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 0.5 }}>
                            <Typography variant="caption" sx={{ opacity: 0.8 }}>
                              {formatTime(message.created_at)}
                              {message.updated_at && message.updated_at !== message.created_at && ' (изменено)'}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              {message.direction === 'outgoing' && (
                                message.status === 'sent' ? (
                                  <CheckCircleIcon sx={{ fontSize: 16, opacity: 0.8 }} />
                                ) : message.status === 'failed' ? (
                                  <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />
                                ) : message.status === 'sending' ? (
                                  <CircularProgress size={12} />
                                ) : null
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      </React.Fragment>
                      );
                      })}
                    </>
                  )}
                  <div ref={messagesEndRef} />
                </Box>

                {/* Панель выбора сообщений для задачи */}
                {taskSelectionMode && (
                  <Box
                    sx={{
                      p: 2,
                      borderTop: 1,
                      borderColor: 'divider',
                      bgcolor: 'primary.light',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="body2">
                      Выбрано сообщений: {selectedMessagesForTask.length}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button
                        variant="outlined"
                        onClick={handleCancelTaskSelection}
                        size="small"
                      >
                        Отмена
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleOpenCreateTaskDialog}
                        disabled={selectedMessagesForTask.length === 0}
                        size="small"
                        startIcon={<TaskIcon />}
                      >
                        Создать задачу
                      </Button>
                    </Box>
                  </Box>
                )}

                {replyToMessage && (
                  <Box
                    sx={{
                      p: 1.5,
                      mx: 2,
                      mt: 1,
                      mb: -1,
                      bgcolor: 'grey.100',
                      borderRadius: 1,
                      borderLeft: 3,
                      borderColor: 'primary.main',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                    }}
                  >
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, mb: 0.5, color: 'primary.main' }}>
                        Ответ на сообщение
                      </Typography>
                      <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {replyToMessage.text}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={handleCancelReply}
                      sx={{ ml: 1 }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
                <Box
                  component="form"
                  onSubmit={handleSendMessage}
                  sx={{
                    p: 2,
                    borderTop: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    gap: 1,
                    alignItems: 'flex-end',
                  }}
                >
                  <input
                    accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                    style={{ display: 'none' }}
                    id="file-upload"
                    type="file"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setSelectedFile(e.target.files[0]);
                      }
                    }}
                  />
                  <label htmlFor="file-upload">
                    <IconButton
                      component="span"
                      color="primary"
                      disabled={sending}
                      title="Прикрепить файл"
                      sx={{ mb: 'auto' }}
                    >
                      <AttachFileIcon />
                    </IconButton>
                  </label>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                    {selectedFile && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, bgcolor: 'grey.100', borderRadius: 1 }}>
                        <AttachFileIcon fontSize="small" />
                        <Typography variant="body2" sx={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {selectedFile.name}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => setSelectedFile(null)}
                          sx={{ p: 0.5 }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  <TextField
                    fullWidth
                    placeholder={replyToMessage ? "Введите ответ..." : "Введите сообщение..."}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    disabled={sending}
                      onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage(e);
                      }
                        // Shift+Enter - перевод строки (стандартное поведение multiline)
                    }}
                      multiline
                      maxRows={4}
                  />
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <IconButton
                    color="primary"
                      disabled={sending}
                      onClick={() => setTemplatesDialogOpen(true)}
                      title="Выбрать шаблон"
                  >
                      <InsertDriveFileIcon />
                  </IconButton>
                  </Box>
                </Box>
              </>
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Box sx={{ textAlign: 'center' }}>
                  <ChatIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                  <Typography variant="h6" color="text.secondary">
                    Выберите чат для начала переписки
                  </Typography>
                </Box>
              </Box>
            )}
          </Paper>
        </Box>

        {/* Меню для чата */}
        <Menu
          anchorEl={chatMenuAnchor}
          open={Boolean(chatMenuAnchor)}
          onClose={() => {
            setChatMenuAnchor(null);
            setSelectedChatForMenu(null);
          }}
        >
          <MenuItem onClick={() => {
            setMoveChatDialogOpen(true);
            setChatMenuAnchor(null);
          }}>
            Переместить в папку
          </MenuItem>
        </Menu>

        {/* Диалог перемещения чата */}
        <Dialog open={moveChatDialogOpen} onClose={() => setMoveChatDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Переместить чат</DialogTitle>
          <DialogContent>
            <FormControl fullWidth margin="normal">
              <InputLabel>Выберите папку</InputLabel>
              <Select
                value={selectedChatForMenu?.folder_id || 'no-folder'}
                onChange={(e) => handleMoveChat(e.target.value === 'no-folder' ? null : e.target.value)}
              >
                <MenuItem value="no-folder">Без папки</MenuItem>
                {folders.map(folder => (
                  <MenuItem key={folder.id} value={folder.id}>{folder.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMoveChatDialogOpen(false)}>Отмена</Button>
          </DialogActions>
        </Dialog>

          {/* Меню для сообщения */}
          {selectedMessageForMenu && (
              <Menu
                anchorEl={messageMenuAnchor}
                open={Boolean(messageMenuAnchor)}
                onClose={handleMessageMenuClose}
              >
                  <MenuItem onClick={() => handleReplyToMessage(selectedMessageForMenu)}>
                      <ReplyIcon sx={{ mr: 1, fontSize: 20 }} />
                      Ответить
                  </MenuItem>
                  <MenuItem onClick={() => handleCopyMessageLink(selectedMessageForMenu)}>
                      <ContentCopyIcon sx={{ mr: 1, fontSize: 20 }} />
                      Копировать ссылку
                  </MenuItem>
                  <MenuItem onClick={() => handleCreateTaskFromMessage(selectedMessageForMenu)}>
                      <TaskIcon sx={{ mr: 1, fontSize: 20 }} />
                      Создать задачу
                  </MenuItem>
                  {selectedMessageForMenu.direction === 'outgoing' && (
                      <>
                          <MenuItem 
                            onClick={handleEditMessageOpen}
                            disabled={(() => {
                              if (!selectedMessageForMenu) return false;
                              const messageCreatedAt = new Date(selectedMessageForMenu.created_at);
                              const now = new Date();
                              const diffInMinutes = (now - messageCreatedAt) / (1000 * 60);
                              return diffInMinutes > 5;
                            })()}
                          >
                              <EditIcon sx={{ mr: 1, fontSize: 20 }} />
                              Редактировать
                          </MenuItem>
                          <MenuItem 
                            onClick={handleDeleteMessage} 
                            disabled={(() => {
                              if (!selectedMessageForMenu) return false;
                              const messageCreatedAt = new Date(selectedMessageForMenu.created_at);
                              const now = new Date();
                              const diffInMinutes = (now - messageCreatedAt) / (1000 * 60);
                              return diffInMinutes > 5;
                            })()}
                            sx={{ color: 'error.main' }}
                          >
                              <DeleteIcon sx={{ mr: 1, fontSize: 20 }} />
                              Удалить
                          </MenuItem>
                      </>
                  )}
              </Menu>
          )}


        {/* Диалог редактирования сообщения */}
        <Dialog open={editMessageDialogOpen} onClose={handleEditMessageClose} maxWidth="sm" fullWidth>
          <DialogTitle>Редактировать сообщение</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={editMessageText}
              onChange={(e) => setEditMessageText(e.target.value)}
              margin="normal"
              autoFocus
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditMessageClose}>Отмена</Button>
            <Button onClick={handleEditMessage} variant="contained" disabled={!editMessageText.trim()}>
              Сохранить
            </Button>
          </DialogActions>
        </Dialog>

        {/* Диалог создания задачи */}
        <Dialog open={createTaskDialogOpen} onClose={() => setCreateTaskDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Создать задачу</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Название задачи"
              value={taskForm.title}
              onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Описание"
              value={taskForm.description}
              onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
              margin="normal"
              multiline
              rows={4}
            />
            <TextField
              fullWidth
              label="Дата выполнения"
              type="datetime-local"
              value={taskForm.due_date}
              onChange={(e) => setTaskForm({ ...taskForm, due_date: e.target.value })}
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            {selectedMessagesForTask.length > 0 && (
              <Alert severity="info" sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                  Выбрано сообщений: {selectedMessagesForTask.length}
                </Typography>
                <Box sx={{ maxHeight: 150, overflow: 'auto' }}>
                  {messages
                    .filter(m => selectedMessagesForTask.includes(m.id))
                    .map((msg, idx) => (
                      <Typography key={msg.id} variant="caption" sx={{ display: 'block', mb: 0.5 }}>
                        {idx + 1}. {msg.text.substring(0, 80)}{msg.text.length > 80 ? '...' : ''}
                      </Typography>
                    ))}
                </Box>
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCreateTaskDialogOpen(false)}>Отмена</Button>
            <Button onClick={handleCreateTask} variant="contained" disabled={!taskForm.title.trim()}>
              Создать
            </Button>
          </DialogActions>
        </Dialog>

        {/* Диалог редактирования задачи */}
        <Dialog open={editTaskDialogOpen} onClose={() => setEditTaskDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Редактировать задачу</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Название задачи"
              value={taskForm.title}
              onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Описание"
              value={taskForm.description}
              onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
              margin="normal"
              multiline
              rows={4}
            />
            <TextField
              fullWidth
              label="Дата выполнения"
              type="datetime-local"
              value={taskForm.due_date ? new Date(taskForm.due_date).toISOString().slice(0, 16) : ''}
              onChange={(e) => setTaskForm({ ...taskForm, due_date: e.target.value ? new Date(e.target.value).toISOString() : '' })}
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditTaskDialogOpen(false)}>Отмена</Button>
            <Button onClick={handleEditTask} variant="contained" disabled={!taskForm.title.trim()}>
              Сохранить
            </Button>
          </DialogActions>
        </Dialog>

        {/* Диалог просмотра сообщений задачи */}
        <Dialog 
          open={viewTaskMessagesDialogOpen} 
          onClose={() => setViewTaskMessagesDialogOpen(false)} 
          maxWidth="md" 
          fullWidth
        >
          <DialogTitle>
            Сообщения задачи "{selectedTaskForView?.title}"
          </DialogTitle>
          <DialogContent>
            {selectedTaskForView?.messages && selectedTaskForView.messages.length > 0 ? (
              <Box sx={{ mt: 1 }}>
                {selectedTaskForView.messages.map((msg, index) => (
                  <Paper
                    key={msg.id}
                    sx={{
                      p: 2,
                      mb: 2,
                      borderLeft: 3,
                      borderColor: 'primary.main',
                      cursor: 'pointer',
                      '&:hover': {
                        bgcolor: 'action.hover',
                      },
                    }}
                    onClick={() => {
                      // Переходим к сообщению в чате
                      if (selectedChat) {
                        const params = new URLSearchParams();
                        params.set('project', selectedProjectUuid);
                        params.set('chat', selectedChat.uuid);
                        params.set('message', msg.id);
                        navigate(`/messages?${params.toString()}`);
                        // Прокручиваем к сообщению
                        setTimeout(() => {
                          const messageElement = document.getElementById(`message-${msg.id}`);
                          if (messageElement) {
                            messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            messageElement.style.backgroundColor = 'rgba(25, 118, 210, 0.1)';
                            setTimeout(() => {
                              messageElement.style.backgroundColor = '';
                            }, 2000);
                          }
                        }, 300);
                        setViewTaskMessagesDialogOpen(false);
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        Сообщение {index + 1} из {selectedTaskForView.messages.length}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(msg.created_at).toLocaleString('ru-RU')}
                      </Typography>
                    </Box>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {msg.text || '(медиа-сообщение)'}
                    </Typography>
                    <Typography variant="caption" color="primary" sx={{ mt: 1, display: 'block' }}>
                      Нажмите, чтобы перейти к сообщению в чате
                    </Typography>
                  </Paper>
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Нет связанных сообщений
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => {
                if (selectedTaskForView) {
                  handleCompleteTask(selectedTaskForView);
                }
              }}
              startIcon={selectedTaskForView?.status === 'completed' ? <CheckCircleOutlineIcon /> : <CheckCircleIcon />}
              color={(() => {
                const status = selectedTaskForView?.status;
                if (status === 'completed') return 'default';
                if (status === 'pending') return 'success';
                return 'primary'; // fallback для безопасности
              })()}
              disabled={!selectedTaskForView}
            >
              {selectedTaskForView?.status === 'completed' ? 'Отметить как невыполненную' : 'Отметить как выполненную'}
            </Button>
            <Button 
              onClick={() => {
                if (selectedTaskForView) {
                  handleDeleteTask(selectedTaskForView);
                  setViewTaskMessagesDialogOpen(false);
                }
              }}
              color="error"
              startIcon={<DeleteIcon />}
            >
              Удалить задачу
            </Button>
            <Button onClick={() => setViewTaskMessagesDialogOpen(false)}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        {/* Диалог выбора шаблонов */}
        <Dialog 
          open={templatesDialogOpen} 
          onClose={() => setTemplatesDialogOpen(false)} 
          maxWidth="sm" 
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">Шаблоны сообщений</Typography>
              <Button
                startIcon={<AddIcon />}
                onClick={() => {
                  setTemplateForm({ name: '', text: '' });
                  setSelectedTemplateForEdit(null);
                  setTemplateFormOpen(true);
                }}
                variant="contained"
                size="small"
              >
                Создать
              </Button>
            </Box>
          </DialogTitle>
          <DialogContent>
            {templates.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <DescriptionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                <Typography variant="body1" color="text.secondary">
                  Нет шаблонов. Создайте первый шаблон.
                </Typography>
              </Box>
            ) : (
              <List>
                {templates.map((template) => (
                  <ListItem
                    key={template.id}
                    button
                    onClick={() => handleSelectTemplate(template)}
                    onContextMenu={(e) => handleTemplateMenuOpen(e, template)}
                    sx={{
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: 1,
                      mb: 1,
                      '&:hover': {
                        bgcolor: 'action.hover',
                      },
                    }}
                  >
                    <ListItemText
                      primary={template.name}
                      secondary={
                        <Box>
                          <Typography
                            variant="body2"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              mt: 0.5,
                              mb: 0.5,
                            }}
                          >
                            {template.text}
                          </Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, mt: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              Создан: {template.created_by_username || 'Неизвестно'} • {new Date(template.created_at).toLocaleString('ru-RU')}
                            </Typography>
                            {template.updated_by_username && template.updated_at && (
                              <Typography variant="caption" color="text.secondary">
                                Изменен: {template.updated_by_username} • {new Date(template.updated_at).toLocaleString('ru-RU')}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      }
                    />
                    <IconButton
                      size="small"
                      onClick={(e) => handleTemplateMenuOpen(e, template)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setTemplatesDialogOpen(false)}>Закрыть</Button>
          </DialogActions>
        </Dialog>

        {/* Меню для шаблона */}
        <Menu
          anchorEl={templateMenuAnchor}
          open={Boolean(templateMenuAnchor)}
          onClose={handleTemplateMenuClose}
        >
          <MenuItem onClick={handleEditTemplate}>
            <EditIcon sx={{ mr: 1, fontSize: 20 }} />
            Редактировать
          </MenuItem>
          <MenuItem onClick={handleDeleteTemplate} sx={{ color: 'error.main' }}>
            <DeleteIcon sx={{ mr: 1, fontSize: 20 }} />
            Удалить
          </MenuItem>
        </Menu>

        {/* Диалог создания/редактирования шаблона */}
        <Dialog 
          open={templateFormOpen} 
          onClose={() => {
            setTemplateFormOpen(false);
            setTemplateForm({ name: '', text: '' });
            setSelectedTemplateForEdit(null);
          }} 
          maxWidth="sm" 
          fullWidth
        >
          <DialogTitle>
            {selectedTemplateForEdit ? 'Редактировать шаблон' : 'Создать шаблон'}
          </DialogTitle>
          <DialogContent>
            {!selectedProjectUuid && !selectedTemplateForEdit && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                Выберите проект для создания шаблона
              </Alert>
            )}
            <TextField
              fullWidth
              label="Название шаблона"
              value={templateForm.name}
              onChange={(e) => setTemplateForm({ ...templateForm, name: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Текст шаблона"
              value={templateForm.text}
              onChange={(e) => setTemplateForm({ ...templateForm, text: e.target.value })}
              margin="normal"
              multiline
              rows={6}
              required
            />
            {selectedTemplateForEdit && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  <strong>Создан:</strong> {selectedTemplateForEdit.created_by_username || 'Неизвестно'} • {new Date(selectedTemplateForEdit.created_at).toLocaleString('ru-RU')}
                </Typography>
                {selectedTemplateForEdit.updated_by_username && selectedTemplateForEdit.updated_at && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Изменен:</strong> {selectedTemplateForEdit.updated_by_username} • {new Date(selectedTemplateForEdit.updated_at).toLocaleString('ru-RU')}
                  </Typography>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setTemplateFormOpen(false);
              setTemplateForm({ name: '', text: '' });
              setSelectedTemplateForEdit(null);
            }}>
              Отмена
            </Button>
            <Button 
              onClick={handleCreateTemplate} 
              variant="contained" 
              disabled={!templateForm.name.trim() || !templateForm.text.trim() || (!selectedProjectUuid && !selectedTemplateForEdit)}
            >
              {selectedTemplateForEdit ? 'Сохранить' : 'Создать'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Toast уведомление */}
        <Snackbar
          open={toastOpen}
          autoHideDuration={3000}
          onClose={() => setToastOpen(false)}
          message={toastMessage}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        />
      </Container>
    </Layout>
  );
};

export default Messages;
